<template>
	<div class="FBMOrder">
		<div class="FBMOrder_top">
			<h3>自发货订单</h3>
			<div style="float: right">
				<el-button type="warning" @click="showFilter = !showFilter">{{ showFilter ? '隐藏筛选条件' : '显示筛选条件'
				}}</el-button>
			</div>
		</div>
		<el-collapse-transition>
			<div v-show="showFilter">
				<el-form :model="ruleForm" ref="ruleForm" :label-position="labelPosition" label-width="5.8vw" inline
					class="custom-formScreen">
					<el-form-item label="选择分公司" prop="branchCompany" v-if="
						[1].includes(str.type) &&
						str.superDepartmentName !== '客服部' &&
						str.superDepartmentName !== '常规客服部'
					">
						<el-select v-model="value6" placeholder="请选择" @change="shopChange6" value-key="company_id"
							filterable>
							<el-option v-for="item in arr6" :key="item.company_id" :label="item.companyName"
								:value="item"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="选择子公司" prop="sonCompany" v-if="[2, 1].includes(str.type)">
						<el-select v-model="value7" placeholder="请选择" value-key="rid" @change="shopChange7" filterable>
							<el-option v-for="item in arr7" :key="item.company_id" :label="item.companyName"
								:value="item"></el-option>
						</el-select>
					</el-form-item>
					<!-- <el-form-item label="选择部门">
												<el-select
														v-model="value1"
														placeholder="请选择"
														@change="shopChange1"
														v-bind:disabled="disabledInput"
												>
														<el-option
																v-for="item1 in this.arr"
																:key="item1.value"
																:label="item1.departmentName"
																:value="item1"
														></el-option>
												</el-select>
										</el-form-item>-->

					<el-form-item label="选择平台">
						<el-select v-model="sellerType" filterable placeholder="请选择" @change="shopChange8" clearable>
							<el-option v-for="item in platform" :key="item.sellerType" :label="item.itemTypeName"
								:value="item.sellerType"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="选择分部门" v-if="!disabledInput2">
						<el-select v-model="value2" filterable placeholder="请选择" @change="shopChange2">
							<el-option v-for="item2 in this.arr1" :key="item2.value" :label="item2.departmentName"
								:value="item2"></el-option>
						</el-select>
					</el-form-item>

					<el-form-item label="选择组" v-if="!disabledInput3">
						<el-select v-model="value3" filterable placeholder="请选择" @change="shopChange3">
							<el-option v-for="item3 in this.arr2" :key="item3.value" :label="item3.groupName"
								:value="item3"></el-option>
						</el-select>
					</el-form-item>

					<el-form-item label="选择员工" v-if="!disabledInput4">
						<el-select v-model="value4" filterable placeholder="请选择" @change="shopChange4">
							<el-option v-for="item4 in this.arr3" :key="item4.value" :label="item4.roleUserName"
								:value="item4"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="选择店铺" prop="shopvalue">
						<el-select v-model="value5" filterable placeholder="请选择" clearable @change="shopChange5">
							<el-option v-for="item5 in this.arr4" :key="item5.value" :label="item5.shopName"
								:value="item5" :style="{ color: item5.state1 === 0 ? 'red' : '' }"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="采购需求状态" prop="purchaseDemandValue">
						<el-select v-model="ruleForm.demandValue" placeholder="请选择" @change="changeDemand"
							@clear="changeDemand" clearable>
							<el-option v-for="(item, index) in demandValue" :key="index" :label="item.label"
								:value="item.label"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="订单状态" prop="Ymxvalue">
						<el-select @change="chanPurchase" v-model="ruleForm.Ymxvalue" placeholder="请选择" clearable
							filterable>
							<el-option v-for="(item, index) in Ymxpurchase" :key="index" :label="item.label"
								:value="item.label"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="采购状态" prop="purchaseValue">
						<el-select v-model="ruleForm.purchaseValue" placeholder="请选择" @change="changePurchase"
							@clear="changePurchase" clearable>
							<el-option v-for="(item, index) in purchaseValue" :key="index" :label="item.label"
								:value="item.label"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="国内发货状态" prop="domesticvalue">
						<el-select v-model="ruleForm.domesticvalue" placeholder="请选择" @change="chanDomestic" filterable
							clearable>
							<el-option v-for="(item, index) in domestic" :key="index" :label="item.label"
								:value="item.value"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="国内物流状态" prop="domesticLogisticsStatus">
						<el-select v-model="ruleForm.domesticLogisticsStatus" placeholder="请选择"
							@change="chanDomesticLogisticsStatus" filterable clearable>
							<el-option v-for="(item, index) in logisticsStatus" :key="index" :label="item.label"
								:value="item.value"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="国际发货状态" prop="channelStatus">
						<el-select v-model="ruleForm.channelStatus" placeholder="请选择" @change="chanDomestic" filterable
							clearable>
							<el-option v-for="(item, index) in domestic1" :key="index" :label="item.label"
								:value="item.value"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="国际物流状态" prop="internationalLogisticsStatus">
						<el-select v-model="ruleForm.internationalLogisticsStatus" placeholder="请选择"
							@change="chanInternationalLogisticsStatus" filterable clearable>
							<el-option v-for="(item, index) in logisticsStatus" :key="index" :label="item.label"
								:value="item.value"></el-option>
						</el-select>
					</el-form-item>
					<!-- <el-form-item label="国际物流" prop="channelStatus">
						<el-select
							@change="chanDomestic"
							v-model="ruleForm.channelStatus"
							placeholder="请选择"
							filterable
							clearable
						>
							<el-option
								v-for="(item, index) in domestic1"
								:key="index"
								:label="item.label"
								:value="item.value"
							></el-option>
						</el-select>
					</el-form-item> -->
					<el-form-item label="国家" prop="countryMark">
						<el-select v-model="ruleForm.countryMark" clearable filterable>
							<el-option v-for="item in listCountry" :key="item.id" :label="item.countryName"
								:value="item.countryCode"></el-option>
						</el-select>
					</el-form-item>
					<!-- <el-form-item label="国内物流" prop="domesticvalue">
						<el-select
							@change="chanDomestic"
							v-model="ruleForm.domesticvalue"
							placeholder="请选择"
							filterable
							clearable
						>
							<el-option
								v-for="(item, index) in domestic"
								:key="index"
								:label="item.label"
								:value="item.value"
							></el-option>
						</el-select>
					</el-form-item> -->
					<el-form-item label="开始日期" prop="starttime">
						<el-date-picker v-model="ruleForm.starttime" align="right" type="datetime" placeholder="选择日期"
							format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
						<!-- @change="startTime" -->
					</el-form-item>
					<el-form-item label="结束日期" prop="endtime">
						<el-date-picker v-model="ruleForm.endtime" align="right" type="datetime" placeholder="选择日期"
							format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
						<!-- @change="endTime" -->
					</el-form-item>
					<el-form-item label="采购预估状态" prop="purchaseEstimated">
						<el-select v-model="ruleForm.purchaseEstimated" placeholder="请选择" clearable>
							<el-option label="未预估" value="0"></el-option>
							<el-option label="已预估" value="1"></el-option>
							<el-option label="真实数据" value="2"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="物流预估状态" prop="logisticsEstimated">
						<el-select v-model="ruleForm.logisticsEstimated" placeholder="请选择" clearable>
							<el-option label="未预估" value="0"></el-option>
							<el-option label="已预估" value="1"></el-option>
							<el-option label="真实数据" value="2"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="地址状态" prop="addressStatus">
						<el-select v-model="ruleForm.addressStatus" placeholder="请选择" clearable>
							<el-option label="有地址" value="1"></el-option>
							<el-option label="无地址" value="0"></el-option>
						</el-select>
					</el-form-item>
					<el-row>
						<el-form-item label="国际运单" prop="endtime">
							<el-input placeholder="请输入国际运单" v-model.trim="ruleForm.conveyNumber"></el-input>
						</el-form-item>
						<el-form-item label="国内运单" prop="endtime">
							<el-input placeholder="请输入国内运单" v-model.trim="ruleForm.internalConveyNumber"></el-input>
						</el-form-item>
						<el-form-item label="系统SKU" prop="systemSku">
							<el-input placeholder="系统SKU" v-model.trim="ruleForm.systemSku"></el-input>
						</el-form-item>
						<el-form-item label="SKU" prop="sku">
							<el-input placeholder="SKU" v-model.trim="ruleForm.sku"></el-input>
						</el-form-item>
						<el-form-item prop="input" label="订单ID/订单号" style="width: 35%">
							<el-input v-model.trim="input" placeholder="请输入订单ID、订单号" @change="Search2"></el-input>
						</el-form-item>
						<el-form-item prop="input" label="多个订单号" style="width: 40%">
							<el-input v-model.trim="inputList" style="width: calc(100% - 140px);"
								placeholder="请输入多个订单号，空格分开" @change="Search2"></el-input>
							<el-button type="primary" style="margin-left: 10px;" @click="Search2">搜索</el-button>
							<el-button type="primary" @click="searchReset">重置</el-button>
						</el-form-item>
					</el-row>
					<el-form-item label="订单状态：" style="width:100%;">
						<el-radio-group v-model="ruleForm.resource1" @change="radiochange1">
							<template v-for="item in this.colorList1">
								<el-radio :key="item.id" :label="item.itemTypeId"
									@click.native.prevent="cancelSelect(item.itemTypeId, 'resource1')">{{
										item.itemTypeName
									}}</el-radio>
							</template>
						</el-radio-group>
					</el-form-item>

					<el-form-item label="订单类型：" style="width:100%;">
						<el-radio-group v-model="ruleForm.resource4" @change="radiochange4">
							<template v-for="item in this.colorList4">
								<el-radio :key="item.id" :label="item.itemTypeId"
									@click.native.prevent="cancelSelect(item.itemTypeId, 'resource4')">{{
										item.itemTypeName
									}}</el-radio>
							</template>
						</el-radio-group>
					</el-form-item>

					<el-form-item label="国际运单状态：" style="width:100%;">
						<el-radio-group v-model="ruleForm.resource3" @change="radiochange3">
							<template v-for="item in this.colorList3">
								<el-radio :key="item.id" :label="item.itemTypeId" v-if="
									item.itemTypeId == 1 ||
									item.itemTypeId == 2 ||
									item.itemTypeId == 3 ||
									item.itemTypeId == 4 ||
									item.itemTypeId == 5 ||
									item.itemTypeId == 6 ||
									item.itemTypeId == 7 ||
									item.itemTypeId == 8 ||
									item.itemTypeId == 9 ||
									item.itemTypeId == 10 ||
									item.itemTypeId == 11 ||
									item.itemTypeId == 12
								" @click.native.prevent="cancelSelect(item.itemTypeId, 'resource3')">{{ item.itemTypeName }}</el-radio>
							</template>
						</el-radio-group>
					</el-form-item>

					<el-form-item label="运单更新状态：" style="width:100%;">
						<el-tooltip class="item" effect="dark" content="该功能可与海逊渠道部沟通国际物流相关问题" placement="top">
							<!-- <label class="el-form-item__label" style="width:120px;"
								></label
							> -->
						</el-tooltip>
						<el-radio-group v-model="ruleForm.resource3" @change="radiochange3">
							<template v-for="item in this.colorList3">
								<el-radio :key="item.id" :label="item.itemTypeId" v-if="item.itemTypeId >= 13"
									@click.native.prevent="cancelSelect(item.itemTypeId, 'resource3')">{{
										item.itemTypeName }}</el-radio>
							</template>
						</el-radio-group>
					</el-form-item>

					<el-form-item label="国内运单状态：" style="width:100%;">
						<el-radio-group v-model="ruleForm.resource2" @change="radiochange2">
							<template v-for="item in this.colorList2">
								<el-radio :key="item.id" :label="item.itemTypeId"
									@click.native.prevent="cancelSelect(item.itemTypeId, 'resource2')">{{
										item.itemTypeName
									}}</el-radio>
							</template>
						</el-radio-group>
					</el-form-item>

					<el-form-item label="查漏选择：" style="width:100%;">
						<el-radio-group v-model="radioTime" @change="radioChangeTime">
							<el-radio label="3-7" @click.native.prevent="cancelSelect1('3-7')">国内采购（3-7天）</el-radio>
							<el-radio label="8-11" @click.native.prevent="cancelSelect1('8-11')">国际发货（8-11天）</el-radio>
							<el-radio label="25" @click.native.prevent="cancelSelect1('25')">国际到达（25天以上）</el-radio>
						</el-radio-group>
					</el-form-item>
				</el-form>
			</div>
		</el-collapse-transition>

		<!-- 添加loading -->
		<div class="order_list" v-loading="loading" element-loading-text="拼命加载中"
			element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)">
			<div class="search-result oh">
				<p class="search-result-text">
					符合条件的订单共有
					<span>{{ total || 0 }}</span>
					个
					<!-- <el-button size="small" type="primary" :loading="uploading" @click="$refs.freightExcel.click()">
						导入包裹数据
					</el-button>

					<input ref="freightExcel" type="file" accept=".xlsx,.xls" style="display: none"
						@change="handleFreightExcel"> -->
				</p>
				<el-row class="right" type="flex" justify="flex-endd" align="middle">
					<div style="margin-right:20px;">
						<el-button type="primary" @click="showSku" :disabled="disabledSku">快速添加别名</el-button>

					</div>

					<div style="margin-right:20px;">
						<el-button type="primary" :disabled="colordisabled"
							@click="handleProcurement">生成采购需求</el-button>
					</div>

					<div style="margin-right:20px;">
						<el-button type="primary" :disabled="colordisabled" @click="dialogSetFormVisible = true"
							v-if="str.system == 1 || str.system == 2 || str.superDepartmentName == '财务部'">批量预估</el-button>
					</div>

					<div style="margin-right:20px;">
						<el-dropdown trigger="click" @command="handleCommand1">
							<el-button type="primary" :disabled="colordisabled">
								订单状态标记<i class="el-icon-arrow-down el-icon--right"></i>
							</el-button>
							<el-dropdown-menu slot="dropdown">
								<div v-for="item in this.colorList1" :key="item.itemTypeId">
									<el-dropdown-item :command="item.itemTypeId">{{
										item.itemTypeName
									}}</el-dropdown-item>
								</div>
							</el-dropdown-menu>
						</el-dropdown>
					</div>

					<div style="margin-right:20px;">
						<el-dropdown trigger="click" @command="handleCommand3">
							<el-button type="primary" :disabled="colordisabled">
								国际运单标记<i class="el-icon-arrow-down el-icon--right"></i>
							</el-button>
							<el-dropdown-menu slot="dropdown">
								<div v-for="item in this.colorList3" :key="item.itemTypeId">
									<el-dropdown-item :command="item.itemTypeId">{{
										item.itemTypeName
									}}</el-dropdown-item>
								</div>
							</el-dropdown-menu>
						</el-dropdown>
					</div>

					<!-- <div style="margin-right:20px;">
						<el-dropdown trigger="click" @command="handleCommand2">
							<el-button type="primary" :disabled="colordisabled">
								国内运单标记<i class="el-icon-arrow-down el-icon--right"></i>
							</el-button>
							<el-dropdown-menu slot="dropdown">
								<div v-for="item in this.colorList2">
									<el-dropdown-item :command="item.itemTypeId">{{
										item.itemTypeName
									}}</el-dropdown-item>
								</div>
							</el-dropdown-menu>
						</el-dropdown>
					</div> -->

					<div style="margin-right: 20px;color: rgb(96, 98, 102);font-size: 14px;line-height: 40px;">
						可用金额：{{ companyInfo.buckleBalance }}
					</div>
					<div style="margin-right: 20px;color: rgb(96, 98, 102);font-size: 14px;line-height: 40px;">
						实际金额：{{ companyInfo.balance }}
					</div>
					<template v-if="str.type === 3">
						<el-button type="primary" @click="shangchuan">
							上传运单
						</el-button>
						<el-button type="primary" @click="handleSync(1)">
							同步订单
						</el-button>
						<el-popover
							placement="top"
							width="300"
							v-model="visibleSetting">
							<p class="popover-title">自定义列</p>
							<el-checkbox-group class="header-group" v-model="selectHeader">
								<el-checkbox v-for="h in allTableHeader" :key="h.prop" :label="h.prop">{{
									h.label }}</el-checkbox>
							</el-checkbox-group>
							<div style="text-align: right; margin: 0">
								<el-button size="mini" type="text" @click="visibleSetting = false">取消</el-button>
								<el-button type="primary" size="mini" @click="saveHeader">确定</el-button>
							</div>
							<el-button slot="reference" class="icon-button" type="text" icon="el-icon-s-tools" circle ></el-button>
						</el-popover>
						<el-button type="primary" @click="handleSync(2)">
							批量同步订单
						</el-button>
						<el-tooltip class="item" effect="dark" content="根据勾选的订单进行拉取，无需选择店铺" placement="top">
							<el-button type="primary" @click="syncOrders">批量同步订单2</el-button>
						</el-tooltip>
						<el-popover placement="left" trigger="click" v-if="exportBool">
							<div>
								<el-date-picker v-model="exportTime" type="datetimerange" size="small"
									value-format="yyyy-MM-dd HH:mm:ss" range-separator="至" start-placeholder="开始日期"
									end-placeholder="结束日期" style="margin-bottom: 10px;">
								</el-date-picker>
								<div style="margin-bottom: 10px;">
									<el-radio-group v-model="exportVersion" size="small">
										<el-radio label="1">标准版</el-radio>
										<el-radio label="2">优化版（批量查询）</el-radio>
									</el-radio-group>
								</div>
								<div v-if="exportLoading" style="text-align: center; padding: 10px 0;">
									<i class="el-icon-loading"></i>
									<span style="margin-left: 8px;">正在导出，请稍候...</span>
								</div>
								<el-button type="primary" @click="handleExport"
									style="float: right; margin-left: 10px;">
									确定
								</el-button>
							</div>
							<el-button type="primary" slot="reference">
								订单导出
							</el-button>
						</el-popover>
						<!-- 店铺订单导出（独立按钮） -->
						<el-popover placement="left" trigger="click" v-if="!exportBool">
							<div>
								<el-date-picker v-model="shopExportTime" type="datetimerange" size="small"
									value-format="yyyy-MM-dd HH:mm:ss" range-separator="至" start-placeholder="开始日期"
									end-placeholder="结束日期" style="margin-bottom: 10px;">
								</el-date-picker>
								<div style="margin-bottom: 10px;">
									<el-select v-model="shopExportId" placeholder="请先在上方选择员工和店铺" size="small" clearable filterable style="width: 100%;" :disabled="exportShopList.length === 0">
										<el-option v-for="shop in exportShopList" :key="shop.sellerInfoId" :label="shop.shopName" :value="shop.sellerInfoId"></el-option>
									</el-select>
									<div v-if="exportShopList.length === 0" style="color: #909399; font-size: 12px; margin-top: 5px;">
										提示：请在上方先选择员工和店铺
									</div>
								</div>
								<div v-if="shopExportLoading" style="text-align: center; padding: 10px 0;">
									<i class="el-icon-loading"></i>
									<span style="margin-left: 8px;">正在导出，请稍候...</span>
								</div>
								<el-button type="primary" @click="handleShopExport"
									style="float: right; margin-left: 10px;">
									确定
								</el-button>
							</div>
							<el-button type="success" slot="reference">
								店铺订单导出
							</el-button>
						</el-popover>

					</template>
				</el-row>
			</div>

			<el-table border :header-cell-style="{ textAlign: 'center' }" :data="tableData"
				style="width: 100%;margin-bottom:50px;" @selection-change="handleSelectionChange" @header-dragend="handleHeaderDragend"
				v-loading="loadingStatus" ref="orderTable">
				<el-table-column type="selection" width="55" align="center"></el-table-column>
				<el-table-column v-for="h in tableHeader" :key="h.prop" :prop="h.prop" :label="h.label" :width="h.width" :align="h.align || 'center'">
					<template slot-scope="scope">
						<template v-if="h.prop === 'amazonOrderId'" >
							<p v-show="scope.row.orderNumber">订单编码：{{ scope.row.orderNumber }}</p>
							<p @click="copyTextToClipboard(scope.row.amazonOrderId)">订单号：{{ scope.row.amazonOrderId }}</p>
							<p @click="copyTextToClipboard(scope.row.id)">订单ID：{{ scope.row.id }}</p>
							<p v-show="scope.row.purchaseDate">下单时间：{{ scope.row.purchaseDate }}</p>
							<p v-show="scope.row.latestShipDate">最后发货时间：{{ scope.row.latestShipDate }}</p>
							<p v-show="scope.row.latestShipDate" v-if="getRemainingTime(scope.row.latestShipDate)">剩余发货时间：{{
								getRemainingTime(scope.row.latestShipDate) }}
							</p>
							<p v-if="scope.row.shipmentBoxId !== null && scope.row.shipmentBoxId !== ''"
								@click="copyTextToClipboard(scope.row.shipmentBoxId)">运输编号：{{ scope.row.shipmentBoxId }}</p>
							<p v-if="scope.row.paymentDetails !== null && scope.row.paymentDetails !== '' && scope.row.paymentDetails !== '[]' && JSON.parse(scope.row.paymentDetails).filter(item => item.payStatus === 'paid')[0] != null && JSON.parse(scope.row.paymentDetails).filter(item => item.payStatus === 'paid')[0].payChannelDealId != null"
								@click="copyTextToClipboard(JSON.parse(scope.row.paymentDetails).filter(item => item.payStatus === 'paid')[0].payChannelDealId)">
								交易号：{{JSON.parse(scope.row.paymentDetails).filter(item => item.payStatus ===
									'paid')[0].payChannelDealId}}</p>
							<el-row type="flex" align="middle">
								<el-tag style="margin-right:5px;" v-for="tag in scope.row.orderMarkItems"
									:color="tag.itemName" :key="tag.id" effect="dark" size="mini" :type="tag.type">
									{{ tag.itemTypeName }}
								</el-tag>
								<el-tag style="margin-right:5px;" v-if="scope.row.outInterceptStatus == 1" color="red"
									effect="dark" size="mini">
									拦截
								</el-tag>
								<el-popover
									v-if="scope.row.addressDuplicate == 1"
									placement="top"
									trigger="hover"
									:content="scope.row.duplicateOrderIds">
									<el-tag slot="reference" style="margin-right:5px;" type="success"
										effect="dark" size="mini">
										复购
									</el-tag>
								</el-popover>
								<el-tag style="margin-right:5px;"
									:color="scope.row.orderType ? colorList4[scope.row.orderType].itemName : '#fff'"
									effect="dark" size="mini" v-if="scope.row.orderType">
									{{ scope.row.orderType ? colorList4[scope.row.orderType].itemTypeName : '' }}
								</el-tag>
								<el-tooltip class="item" effect="dark" content="订单冻结" placement="bottom"
									v-if="scope.row.isFreeze === 1">
									<i class="element-icons hx-snow"
										style="font-size: 40px;color: #1296db;line-height: 40px;"></i>
								</el-tooltip>
								<el-tooltip class="item" effect="dark" content="订单解冻" placement="bottom"
									v-if="scope.row.isFreeze === 2">
									<img width="40px" height="40px" src="../../assets/imags/sun.png" alt="" />
									<!-- <i class="element-icons hx-snow" style="font-size: 40px;color: #1296db;line-height: 40px;"></i> -->
								</el-tooltip>
								<el-popover v-if="scope.row.orderRemarks.length != 0" style="display:flex;"
									placement="top-start" trigger="hover">
									<h3>订单备忘录</h3>
									<div v-for="(item, index) in scope.row.orderRemarks" :key="index">
										<span>{{ item.roleName }}</span>
										<span v-if="item.userName !== null">-</span>
										<span>{{ item.userName }}</span>: <span>{{ item.remarkContent }}</span>--
										<span>{{ item.createTime }}</span>
									</div>
									<img class="Memo" slot="reference" src="../../assets/imags/备忘录.png" alt="" />
								</el-popover>
								<el-popover v-if="scope.row.channelRemarks.length != 0" style="display:flex;"
									placement="top-start" trigger="hover">
									<h3>渠道备忘录</h3>
									<div v-for="(item, index) in scope.row.channelRemarks" :key="index">
										<span>{{ item.roleName }}</span>
										<span v-if="item.userName !== null">-</span>
										<span>{{ item.userName }}</span>: <span>{{ item.remarkContent }}</span>--
										<span>{{ item.createTime }}</span>
									</div>
									<img class="Memo1" slot="reference" src="../../assets/imags/备忘录1.png" alt="" />
								</el-popover>
							</el-row>
							<el-row type="flex" align="middle">
								<el-popover placement="top" width="500" trigger="click" @show="popoverShows(scope.row.id)">
									<template slot="reference">
										<i class="el-icon-tickets"
											style="margin-top: 5px; font-size: 17px;cursor: pointer;"></i>
										<!-- <el-button type="primary">日志</el-button> -->
									</template>
									<el-timeline>
										<el-timeline-item v-for="(activity, index) in activities" :key="index"
											:timestamp="activity.createTime">
											{{ activity.operateName }}
										</el-timeline-item>
									</el-timeline>
								</el-popover>
							</el-row>
						</template>
						<template v-else-if="h.prop === 'orderItems'">
							<div class="details" v-for="(item, index) in scope.row.orderItems" :key="index">
								<div class="details_left">
									<el-popover trigger="hover" placement="right" prop="orderItems.imageUrl"
										v-if="item.imageUrl">
										<img referrer="no-referrer|origin|unsafe-url" :src="item.imageUrl" alt
											style="width:500px;height:500px;" />
										<div class="scope_img" slot="reference">
											<img referrer="no-referrer|origin|unsafe-url" :src="item.imageUrl" alt />
										</div>
									</el-popover>
									<el-button type="text" size="mini" v-else @click="getOriginalImg(item)"
										style="padding: 0;">查看原图</el-button>
								</div>
								<div class="details_right">
									<div style="width: 100%;" v-if="scope.row.money == null">
										<strong>price:</strong> - -
									</div>
									<div style="width: 100%;" v-if="scope.row.money !== null">
										<strong style="color:black">price:</strong> {{ item.itemAmount }}
										{{ item.itemCurrencyCode }}
									</div>
									<div style="width: 100%;" v-if="item.property !== null">
										<strong style="color:black;">属性:</strong>
										<span v-if="!showFullText" class="truncate-text"
											@click="copyTextToClipboard(item.property)">
											{{ item.property.length <= 50 ? item.property : item.property.substr(0, 50)
												+ "..." }} <a href="#" @click="showFullText = true">展开</a>
										</span>
										<span v-else @click="copyTextToClipboard(item.property)">
											{{ item.property }}
											<a href="#" @click="showFullText = false">收起</a>
										</span>
									</div>
									<div style="width: 100%;" v-if="item.customizeInfo">
										<strong style="color:black;">定制信息:</strong> 

										<span v-if="!showFullInfo" class="truncate-text"
											@click="copyTextToClipboard(item.customizeInfo)">
											{{ item.customizeInfo.length <= 50 ? item.customizeInfo : item.customizeInfo.substr(0, 50)
												+ "..." }} <a href="#" @click="showFullInfo = true">展开</a>
										</span>
										<span v-else @click="copyTextToClipboard(item.customizeInfo)">
											{{ item.customizeInfo }}
											<a href="#" @click="showFullInfo = false">收起</a>
										</span>
									</div>
									<div style="width: 100%;color:#dc143c" v-show="item.systemSku"
										@click="copyTextToClipboard(item.systemSku)">
										<strong>系统SKU:</strong> {{ item.systemSku }}
									</div>
									<div style="width: 100%;" @click="copyTextToClipboard(item.sellerSKU)">
										<strong style="color:black">SKU:</strong> {{ item.sellerSKU }}
									</div>
									<div style="width: 100%;" @click="copyTextToClipboard(item.quantityOrdered)">
										<strong style="color:black">数量:</strong> {{ item.quantityOrdered }}
									</div>
									<div style="width: 100;" v-show="item.productSku">
										<strong style="color:black">产品SKU:</strong> {{ item.productSku }}
									</div>
									<div style="width: 100;" v-show="item.channel">
										<strong style="color:black">订单渠道:</strong> {{ item.channel }}
									</div>
									<div style="width: 100;" v-show="item.logisticsType">
										<strong style="color:black">客户物流方式:</strong> {{ item.logisticsType }}
									</div>
									<div style="width: 100;" v-show="item.logisticsServiceName">
										<strong style="color:black">物流服务名称:</strong> {{ item.logisticsServiceName }}
									</div>
									<!-- <div style="width: 100%;" v-if="scope.row.seller.sellerType == 2">
										海逊SKU: {{ item.sellerSKU }}
									</div> -->
									<el-divider
										v-if="scope.row.orderItems.length > 1 && index != (scope.row.orderItems.length - 1)"
										class="orderDivider" />
								</div>
							</div>
						</template>
						<template v-else-if="h.prop === 'costPrice'">
							<span v-if="scope.row.costPrice < 0" style="color:red;">{{ scope.row.costPrice }}</span>
							<span v-if="scope.row.costPrice >= 0">{{
								scope.row.costPrice
							}}</span>
						</template>
						<template v-else-if="h.prop === 'profitPrice'">
							<div v-if="scope.row.profitPrice < 0" style="color:red;">
								{{ scope.row.profitPrice }}
							</div>
							<div v-if="scope.row.profitPrice >= 0">
								<span v-if="scope.row.isDesignate && scope.row.profitPrice >= 1000" style="color:red; font-weight: bold;">
									{{ scope.row.profitPrice }}
								</span>
								<span v-else>
									{{ scope.row.profitPrice }}
								</span>
							</div>
						</template>
						<template v-else-if="h.prop === 'countryMarks'">
							{{ scope.row.countryMarks.countryName }}
						</template>
						<template v-else-if="h.prop === 'orderStatus'">
							<div v-if="scope.row.orderStatus === '未发货'">
								<span style="color:red">{{
									scope.row.orderStatus
								}}</span>
							</div>
							<div v-if="scope.row.orderStatus != '未发货'">
								<span>{{ scope.row.orderStatus }}</span>
							</div>
						</template>
						<template v-else-if="h.prop === 'orderChannelsNumber'">
							<template v-for="(item, index) in scope.row.orderChannels" >
								<template v-if="item.status != 1">
									<el-popover :disabled="!scope.row.queryTrackSwitch" placement="top" width="700"
										trigger="hover" :open-delay="1000" :key="index"
										@show="popoverShowTrack17('international', item)">
										<template>
											<div style="width: 100%;text-align: center;" v-if="popoverStatus">
												{{ popoverText }}
											</div>
											<div style="width: 100%;" v-else>
												<div style="margin-bottom: 10px;">
													<span>运单号：{{
														popoverInfo.number
													}}</span>
													<span v-if="popoverInfo.track_info" style="margin-left: 10px;"> {{
														popoverInfo.track_info.latest_status.status
													}}</span>
													<span v-if="popoverInfo.track_info" style="margin-left: 10px;">
														发往->{{
															popoverInfo.track_info.shipping_info.recipient_address.country
														}}</span>
												</div>
												<div v-if="popoverInfo.track_info" style="margin-bottom: 10px;">
													<span>时效信息: </span>
													<span style="margin-left: 10px;">订单:{{
														popoverInfo.track_info.time_metrics.days_after_order
													}}天</span>
													<span style="margin-left: 10px;">运输:{{
														popoverInfo.track_info.time_metrics.days_of_transit
													}}天</span>
													<span style="margin-left: 10px;">妥投:{{
														popoverInfo.track_info.time_metrics.days_of_transit_done
													}}天</span>
													<span style="margin-left: 10px;">无更新:{{
														popoverInfo.track_info.time_metrics.days_after_last_update
													}}天</span>
												</div>
												<div v-if="popoverInfo.track_info"
													style="height: 200px;overflow: auto;">
													<div v-for="(item,
														index) in popoverInfo.track_info.tracking.providers[0].events" :key="index" style="margin-bottom: 15px;">
														<div>{{ item.description }}</div>
														<div>{{ timeConversion(item.time_iso) }}</div>
													</div>
												</div>
												<div v-else style="height: 200px;overflow:auto;">
													<div v-for="(item, index) in popoverInfo.data" :key="index"
														style="margin-bottom: 15px;">
														<div>{{ item.context }}</div>
														<div>{{ item.time }}</div>
													</div>
												</div>
											</div>
										</template>
										<template slot="reference">
											<el-row type="flex" justify="center" align="middle">
												<div style="cursor: pointer;position:relative;z-index:1"
													@click="queryExternalcall(item)">
													<span :id="item.conveyNumber" :style="{
														color: item.isActive
															? '#51c4d3'
															: '',
													}">{{
													item.conveyNumber
												}}</span>
												</div>
											</el-row>
										</template>
									</el-popover>
								</template>
							</template>
							
							<!-- <el-row type="flex" justify="center" align="middle" v-for="(item, index) in scope.row.orderChannels" :key="index">
								<div style="cursor: pointer;" @click="queryExternalcall(item)">
									<span :id="item.conveyNumber" :style="{ color: item.isActive ? '#51c4d3' : '' }">{{ item.conveyNumber + '：' }}</span>
								</div>
								<span v-if="item.status == 0" style="color:blue;">未处理</span>
								<span v-else-if="item.status == 1" style="color:red;">作废</span>
								<span v-else-if="item.status == 2" style="color:blue;">未发货</span>
								<span v-else-if="item.status == 3" style="color:blue;">未发货</span>
								<span v-else-if="item.status == 4" style="color:green;">已发货</span>
							</el-row> -->
							<div>
								<el-tag style="margin-left:5px;" closable @close="handleClose2(scope.row, tag)"
									v-for="tag in scope.row.channelMarkItems" :color="tag.itemName" :key="tag.id"
									effect="dark" size="mini" :type="tag.type">
									{{ tag.itemTypeName }}
								</el-tag>
							</div>
						</template>
						<template v-else-if="h.prop === 'orderChannels'">
							<template v-for="(item, index) in scope.row.orderChannels">
								<div :style="{color: internationalOrderStatus[item.status].color,}" :key="index">
									{{
										internationalOrderStatus[item.status].title
									}}
								</div>
							</template>
						</template>
						<template v-else-if="h.prop === 'channelWeight'">
							<template v-for="(item, index) in scope.row.orderChannels">
								<div :key="index">
									{{ item.channelWeight }}
								</div>
							</template>
						</template>
						<template v-else-if="h.prop === 'purchases'">
							<template v-for="(item, index) in scope.row.purchases">
								<el-popover :disabled="!scope.row.queryTrackSwitch" placement="top" width="500"
									trigger="hover" :open-delay="1000" :key="index"
									@show="popoverShowTrack17('domestic', item)">
									<template>
										<div style="width: 100%;text-align: center;" v-if="popoverStatus">
											{{ popoverText }}
										</div>
										<div style="width: 100%;" v-else>
											<div style="margin-bottom: 10px;">
												<span>运单号：{{
													popoverInfo.number
												}}</span>
												<span v-if="popoverInfo.track_info" style="margin-left: 10px;">{{
													popoverInfo.track_info.latest_status.status
												}}</span>
											</div>
											<div v-if="popoverInfo.track_info" style="margin-bottom: 10px;">
												<span>时效信息: </span>
												<span style="margin-left: 10px;">订单:{{
													popoverInfo.track_info.time_metrics.days_after_order
												}}天</span>
												<span style="margin-left: 10px;">运输:{{
													popoverInfo.track_info.time_metrics.days_of_transit
												}}天</span>
												<span style="margin-left: 10px;">妥投:{{
													popoverInfo.track_info.time_metrics.days_of_transit_done
												}}天</span>
												<span style="margin-left: 10px;">无更新:{{
													popoverInfo.track_info.time_metrics.days_after_last_update
												}}天</span>
											</div>
											<div v-if="popoverInfo.track_info" style="height: 200px;overflow: auto;">
												<div v-for="(item,
													index) in popoverInfo.track_info.tracking.providers[0].events" :key="index" style="margin-bottom: 15px;">
													<div>{{ item.description }}</div>
													<div>{{ timeConversion(item.time_iso) }}</div>
												</div>
											</div>
										</div>
									</template>
									<template slot="reference">
										<el-row type="flex" justify="center" align="middle">
											<div style="cursor: pointer;" @click="
												queryDomesticOrderClick(item)
												">
												<span :style="{
													color: item.isActive
														? '#51c4d3'
														: '',
												}">{{
													item.internalConveyNumber +
													'：'
												}}</span>
											</div>
											<span :style="{
												color:
													item.purchaseStatus < 10000 ? (domesticOrderStatus[item.purchaseStatus] ? domesticOrderStatus[item.purchaseStatus].color : 'red') : 'red',
											}">
												<p v-if="item.purchaseStatus < 10000">
													{{ domesticOrderStatus[item.purchaseStatus] ?
														domesticOrderStatus[item.purchaseStatus].title : '' }}
												</p>
												<p v-else>第三方异常</p>
											</span>
										</el-row>
									</template>
								</el-popover>
							</template>
							<!-- <div v-for="item in scope.row.purchases">
								<span>{{item.internalConveyNumber}}</span>:
								<span v-if="item.purchaseStatus == 1" style="color:#f04b22;">待采购</span>
								<span v-if="item.purchaseStatus == 2" style="color:#1677b3;">已采购</span>
								<span v-if="item.purchaseStatus == 3" style="color:#12a182;">已发货</span>
								<span v-if="item.purchaseStatus == 4" style="color:#835e1d;">已签收</span>
								<span v-if="item.purchaseStatus == 5" style="color:#a8456b;">退货</span>
							</div> -->
							<div>
								<el-tag style="margin-left:5px;" closable @close="handleClose1(scope.row, tag)"
									v-for="tag in scope.row.purchaseMarkItems" :color="tag.itemName" :key="tag.id"
									effect="dark" size="mini" :type="tag.type">
									{{ tag.itemTypeName }}
								</el-tag>
							</div>
						</template>
						<template v-else-if="h.prop === 'purchaseDemandStatus'">
							<div v-if="scope.row.purchaseDemandStatus == '未完成'">
								<span style="color:red">{{
									scope.row.purchaseDemandStatus
								}}</span>
							</div>
							<div v-if="scope.row.purchaseDemandStatus == '已完成'">
								<span>{{ scope.row.purchaseDemandStatus }}</span>
							</div>
						</template>
						<template v-else-if="h.prop === 'purchaseEstimated'">
							<el-tag type="danger" v-if="scope.row.orderCostEstimate.purchaseEstimated == 0"
								size="small">未预估</el-tag>
							<el-tag v-if="scope.row.orderCostEstimate.purchaseEstimated == 1" size="small">已预估</el-tag>
							<el-tag type="success" v-if="scope.row.orderCostEstimate.purchaseEstimated == 2"
								size="small">真实数据</el-tag>
							<el-tag type="info" v-if="scope.row.orderCostEstimate.purchaseEstimated === null"
								size="small">——</el-tag>
						</template>
						<template v-else-if="h.prop === 'logisticsEstimated'">
							<el-tag type="danger" v-if="scope.row.orderCostEstimate.logisticsEstimated == 0"
								size="small">未预估</el-tag>
							<el-tag v-if="scope.row.orderCostEstimate.logisticsEstimated == 1" size="small">已预估</el-tag>
							<el-tag type="success" v-if="scope.row.orderCostEstimate.logisticsEstimated == 2"
								size="small">真实数据</el-tag>
							<el-tag type="info" v-if="scope.row.orderCostEstimate.logisticsEstimated === null"
								size="small">——</el-tag>
						</template>
						<template v-else-if="h.prop === 'logisticsCostEstimate'">
							{{ scope.row.orderCostEstimate[h.prop] }}
						</template>
						<template v-else>
							{{ scope.row[h.prop] }}
						</template>
					</template>
				</el-table-column>
				<el-table-column label="操作" width="80" fixed="right" align="center">
					<template slot-scope="scope">
						<div style="text-align: center;padding: 20px;" @click="operation(scope.row)">
							<i style="font-size: 20px;" class="el-icon-edit-outline"></i>
						</div>
					</template>
				</el-table-column>
			</el-table>

			<div class="page">
				<el-pagination style="margin-right:200px;" layout="total, sizes, prev, pager, next, jumper"
					:page-sizes="[20, 50, 100, 200, 400, 500, 1000]" :page-size="size" :current-page="currentpage" :total="total"
					@size-change="handleSizeChange" @current-change="handleCurrentChange"></el-pagination>
			</div>
		</div>
		<FBModeredit ref="editpanel" @edit="edit" :rate="rate"></FBModeredit>
		<skuAdd ref="skuAdd" :tableData="addSkuTable" @reload="Search"></skuAdd>
		<Waybill ref="Waybill" />
		<!-- 生成采购需求 -->
		<el-dialog title="生成采购需求" :visible.sync="procurementBool" width="30%">
			<!-- <span>这是一段信息</span> -->
			<el-row type="flex" align="middle">
				<label>采购需求:</label>
				<div>
					<el-input v-model="procurementData" style="width:300px;margin-left: 10px;"></el-input>
				</div>
			</el-row>
			<div style="margin-top:20px">
				<label>采购需求填写标准：</label>
				<el-select filterable @change="changeStandard" v-model="listRemarkStandardvalue">
					<el-option v-for="item in listRemarkStandard" :key="item.id" :label="item.typeName"
						:value="item.content"></el-option>
				</el-select>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="procurementCancel">取 消</el-button>
				<el-button type="primary" @click="submitProcurement" :loading="procurementloading"><span
						v-if="this.procurementType == '一次采购'">确认采购</span>
					<span v-if="this.procurementType == '二次采购'">二次采购</span></el-button>
			</span>
		</el-dialog>
		<!-- 同步订单弹出层 -->
		<el-dialog :title="syncIstrue == false ? '同步订单' : '批量同步订单'" :visible.sync="dialog" width="30%">
			<!-- <span>这是一段信息</span> -->
			<el-row type="flex" align="middle">
				<label>订单号:</label>
				<div>
					<el-input placeholder="请输入订单号" v-model="value6" style="width:480px;margin-left: 10px;"></el-input>
				</div>
			</el-row>
			<div style="margin-top:20px">
				<label>请选择店铺：</label>
				<el-select v-model="value" placeholder="请选择" filterable style="width:444px;margin-left: 10px;">
					<el-option v-for="item in options" :key="item.value" :label="item.label"
						:value="item.value"></el-option>
				</el-select>
			</div>
			<div v-if="errorList.length != 0" style="color: red;margin-top: 20px;">
				错误订单如下: <span v-for="(item, index) in errorList" :key="index">第{{ index + 1 }}个:{{ item }} , </span> 请重新填写对应订单号!
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="handleCancel">取 消</el-button>
				<el-button type="primary" @click="handleTrue" :loading="issloading">确 定</el-button>
			</span>
		</el-dialog>
		<!-- 下载订单弹出层 -->
		<el-dialog title="下载订单" :visible.sync="downloadDialog" width="30%">
			<!-- <span>这是一段信息</span> -->
			<div>
				<label>请选择店铺：</label>
				<el-select v-model="downLoadValue" placeholder="请选择" filterable>
					<el-option v-for="item in downloadOptions" :key="item.value" :label="item.label"
						:value="item.value"></el-option>
				</el-select>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="downloadDialog = false">取 消</el-button>
				<el-button type="primary" @click="handleDown" :loading="issloading1">确 定</el-button>
			</span>
		</el-dialog>
		<!-- 上传运单 -->
		<el-dialog title="上传运单" :visible.sync="uploadWaybillDialog" width="60%" top="7vh">
			<el-row type="flex" style="margin-bottom:10px;" align="middle">
				<div style="margin-right:10px;">
					<label>请选择平台：</label>
					<el-select filterable placeholder="请选择" @change="uploadShopclass" v-model="sellerTypeID"
						value-key="sellerType">
						<el-option v-for="item in platform" :key="item.sellerType" :label="item.itemTypeName"
							:value="item.sellerType"></el-option>
					</el-select>
				</div>
				<div style="margin-right:10px;">
					<label>请选择站点：</label>
					<el-select filterable v-model="uploadWaybillShop" placeholder="请选择" value-key="shopId"
						@change="uploadWaybillShopChange">
						<el-option v-for="item in optionsUpload" :key="item.shopId" :label="item.optionlable"
							:value="item"></el-option>
					</el-select>
				</div>
				<el-radio-group v-model="waybillType" size="small" @change="handleRadioChange">
					<el-radio-button label="1">运单号</el-radio-button>
					<el-radio-button label="2">转单号</el-radio-button>
				</el-radio-group>

				<el-button style="margin:0 15px" @click="OneOperation" type="primary">渠道同步</el-button>
				<el-button style="margin:0 15px" @click="identifyCarrier" type="primary" v-if="waybillType == '2'" :loading="identifyLoading">发起识别运输渠道商</el-button>
				<el-button style="margin:0 15px" @click="noTreatmentRequired" type="primary">无需处理</el-button>
			</el-row>
			<el-table :data="listTableWaybill" border v-loading="loadingTable"
				:header-cell-style="{ textAlign: 'center' }" @selection-change="handleSelectionWaybillChange"
				max-height="480px">
				<el-table-column type="selection" width="50" align="center"></el-table-column>
				<el-table-column label="订单号/订单ID" align="left" width="200">
					<template slot-scope="scope">
						<p v-show="scope.row.orderNumber">订单编码：{{ scope.row.orderNumber }}</p>
						<p>订单号：{{ scope.row.amazonOrderId }}</p>
						<p>订单ID：{{ scope.row.orderId }}</p>
						<p v-show="scope.row.purchaseDate">订单日期：{{ scope.row.purchaseDate }}</p>
						<p v-show="scope.row.latestShipDate">最后发货时间：{{ scope.row.latestShipDate }}</p>
						<p v-show="scope.row.latestShipDate" v-if="getRemainingTime(scope.row.latestShipDate)">剩余发货时间：{{ getRemainingTime(scope.row.latestShipDate) }}</p>
						<el-row type="flex" align="middle">
							<el-tag style="margin-right:5px;" v-for="tag in scope.row.orderMarkItems"
								:color="tag.itemName" :key="tag.id" effect="dark" size="mini" :type="tag.type">
								{{ tag.itemTypeName }}
							</el-tag>
							<el-tag style="margin-right:5px;" v-if="scope.row.outInterceptStatus == 1" color="red"
								effect="dark" size="mini">
								拦截
							</el-tag>
							<el-tag style="margin-right:5px;" :color="colorList4[scope.row.orderType].itemName"
								effect="dark" size="mini" v-if="scope.row.orderType">
								{{ colorList4[scope.row.orderType].itemTypeName }}
							</el-tag>
							<el-tooltip class="item" effect="dark" content="订单冻结" placement="bottom"
								v-if="scope.row.isFreeze === 1">
								<i class="element-icons hx-snow"
									style="font-size: 40px;color: #1296db;line-height: 40px;"></i>
							</el-tooltip>
							<el-popover v-if="scope.row.orderRemarks.length != 0" style="display:flex;"
								placement="top-start" trigger="hover">
								<h3>订单备忘录</h3>
								<div v-for="(item, i) in scope.row.orderRemarks" :key="i">
									<span>{{ item.roleName }}</span>
									<span v-if="item.userName !== null">-</span>
									<span>{{ item.userName }}</span>: <span>{{ item.remarkContent }}</span>--
									<span>{{ item.createTime }}</span>
								</div>
								<img class="Memo" slot="reference" src="../../assets/imags/备忘录.png" alt="" />
							</el-popover>
							<el-popover v-if="scope.row.channelRemarks.length != 0" style="display:flex;"
								placement="top-start" trigger="hover">
								<h3>渠道备忘录</h3>
								<div v-for="(item, i) in scope.row
									.channelRemarks" :key="i">
									<span>{{ item.roleName }}</span>
									<span v-if="item.userName !== null">-</span>
									<span>{{ item.userName }}</span>: <span>{{ item.remarkContent }}</span>--
									<span>{{ item.createTime }}</span>
								</div>
								<img class="Memo1" slot="reference" src="../../assets/imags/备忘录1.png" alt="" />
							</el-popover>
						</el-row>
					</template>
				</el-table-column>
				<el-table-column label="产品信息" align="left" min-width="250">
					<template slot-scope="scope">
						<template v-for="item in scope.row.orderItems">
							<el-row type="flex" :key="item.id">
								<div class="details_left">
									<el-popover trigger="hover" placement="right" prop="orderItems.imageUrl">
										<img referrer="no-referrer|origin|unsafe-url" :src="item.imageUrl"
											style="width: 500px;height: 500px;" />
										<div class="scope_img" slot="reference">
											<img referrer="no-referrer|origin|unsafe-url" :src="item.imageUrl" />
										</div>
									</el-popover>
								</div>
								<div class="details_right">
									<div style="width: 100%;" v-if="!item.itemAmount">
										price: - -
									</div>
									<div style="width: 100%;" v-else>
										price: {{ item.itemAmount }}
										{{ item.itemCurrencyCode }}
									</div>
									<div style="width: 100%;">
										SKU: {{ item.sellerSKU }}
									</div>
								</div>
							</el-row>
						</template>
					</template>
				</el-table-column>
				<el-table-column prop="channelName" label="店铺" align="center">
					<template slot-scope="scope">
						<span>{{ scope.row.shopName }}</span>
						<span>（{{ scope.row.countryName }}）</span>
					</template>
				</el-table-column>
				<el-table-column prop="channelName" label="渠道名称" align="center"
					:width="waybillType == 1 ? '80' : '200'">
					<template slot-scope="scope">
						<div v-show="waybillType === '1'">
							<div>{{ scope.row.channelName }}</div>
						</div>
						<div v-show="waybillType === '2'">
							<!--                            <el-input v-model="scope.row.channelName"></el-input>-->
							<el-select v-model="scope.row.channelName" filterable allow-create default-first-option>
								<el-option v-for="(item, index) in listChannel" :key="index" :label="item.label"
									:value="item.label">
								</el-option>
							</el-select>
						</div>
					</template>
				</el-table-column>
				<el-table-column v-if="waybillType == '1'" prop="channelWayEn" label="运输方式英文" align="center"
					width="200">
					<template slot-scope="scope">
						<!-- 三态 -->
						<el-select v-if="scope.row.type == 1" filterable v-model="scope.row.channelWayEn"
							placeholder="请选择" @change="hanleChange">
							<el-option v-for="(item, i) in SanTai" :key="i" :label="item.label" :value="item.value">
							</el-option>
						</el-select>
						<!-- 燕文	v-if="scope.row.type == 3" -->
						<el-select v-if="scope.row.type == 3" filterable v-model="scope.row.channelWayEn"
							placeholder="请选择" @change="hanleChange">
							<el-option v-for="(item, i) in YanWen" :key="i" :label="item.label" :value="item.value">
							</el-option>
						</el-select>
						<!-- 递四方 DiSiFang -->
						<el-select v-if="scope.row.type == 6" filterable v-model="scope.row.channelWayEn"
							placeholder="请选择" @change="hanleChange">
							<el-option v-for="(item, i) in DiSiFang" :key="i" :label="item.label" :value="item.value">
							</el-option>
						</el-select>
						<!-- YunTu 云途 -->
						<el-select v-if="
							scope.row.type == 2 ||
							scope.row.type == 7 ||
							scope.row.type == 10
						" v-model="scope.row.channelWayEn" filterable placeholder="请选择" @change="hanleChange">
							<el-option v-for="(item, i) in YunTu" :key="i" :label="item.label" :value="item.value">
							</el-option>
						</el-select>
						<!-- 捷岸 DiSiFang -->
						<el-select v-if="scope.row.type == 12" filterable v-model="scope.row.channelWayEn"
							placeholder="请选择" @change="hanleChange">
							<el-option v-for="(item, i) in JieAn" :key="i" :label="item.label" :value="item.value">
							</el-option>
						</el-select>
						<el-input @change="hanleChange" @blur="channelInp(scope.row.channelWayEn)"
							style="margin-top:10px" v-model="scope.row.channelWayEn"></el-input>
					</template>
				</el-table-column>
				<el-table-column prop="conveyNumber" :label="waybillType === '1' ? '运单号' : '转单号'" align="center"
					width="160">
					<template slot-scope="scope">
						<div v-show="waybillType === '1'">
							<div>{{ scope.row.conveyNumber }}</div>
						</div>
						<div v-show="waybillType === '2'">
							<div>{{ scope.row.transferOrderNumber }}</div>
							<!-- <el-input v-model="scope.row.transferOrderNumber"></el-input> -->
						</div>
					</template>
				</el-table-column>
			</el-table>
			<el-row type="flex" justify="center">
				<el-pagination style="margin-top:20px;" layout="total, sizes, prev, pager, next, jumper"
					:page-sizes="[20, 50, 100, 200, 500, 1000, 2000]" :page-size="waybillSize"
					:current-page="waybillPage" :total="waybillTotal" @size-change="handleSizeWaybillChange"
					@current-change="handleCurrentWaybillChange"></el-pagination>
			</el-row>

			<span slot="footer" class="dialog-footer">
				<el-button @click="uploadWaybillDialog = false">取 消</el-button>
				<el-button type="primary" @click="updateWaybill(1)" v-show="waybillType === '1'">上传运单号</el-button>
				<el-button type="primary" @click="updateWaybill(2)" v-show="waybillType === '2'">上传转单号</el-button>
			</span>
		</el-dialog>
		<el-dialog :visible.sync="originalVisible" width="540px">
			<img referrer="no-referrer|origin|unsafe-url" style="width: 500px;height: 500px;" :src="originalImg"
				alt="" />
		</el-dialog>
		<!-- 设置预估费用 -->
		<el-dialog title="设置预估费用" :visible.sync="dialogSetFormVisible" append-to-body width="35%">
			<el-form ref="ruleFormSet">
				<el-row :gutter="20">
					<el-col :span="12" :offset="0">
						<el-form-item label="采购预估费用">
							<el-input-number v-model="purchaseCostEstimate" size="small" :min="0">
							</el-input-number>
						</el-form-item>
					</el-col>
					<el-col :span="12" :offset="0">
						<el-form-item label="物流预估费用">
							<el-input-number v-model="logisticsCostEstimate" size="small" :min="0">
							</el-input-number>
						</el-form-item>
					</el-col>
				</el-row>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="dialogSetFormVisible = false">取 消</el-button>
				<el-button type="primary" @click="submitSet" :loading="btnSetLoading">确 定</el-button>
			</div>
		</el-dialog>
	</div>
</template>
<script>
let checkedList = []
let timer = null
import './js/externalcall'
import FBModeredit from './FBModeredit/FBModeredit.vue'
import skuAdd from './FBModeredit/skuAdd.vue'
import Waybill from './FBModeredit/Waybill'
import { ajaxPost, Baseurl } from '../../api/api/api'
import ListChannel from './data/listChannel.json'
import { ALL } from './js/channel'
import * as XLSX from 'xlsx'
export default {
	name: 'FBMOrder',
	components: {
		FBModeredit,
		Waybill,
		skuAdd
	},
	data() {
		return {
			showFullText: false,
			showFullInfo: false,
			SanTai: ALL.SanTai,
			YanWen: ALL.YanWen,
			DiSiFang: ALL.DiSiFang,
			YunTu: ALL.YunTu,
			JieAn: ALL.JieAn,
			state: '',
			sellerType: '',
			// headClass: this.common.headClass,
			labelPosition: 'right',
			sondata: {},
			total: 0,
			sleValue: '',
			sleName: '',
			// value1: "",
			value2: '',
			value3: '',
			value4: '',
			value5: '',
			select: '',
			tableData: [],
			states: '',
			issloading: false,
			issloading1: false,
			visibleSetting: false,
			allTableHeader: [
				{label: '订单号/订单ID', prop: 'amazonOrderId', width: 220, align: 'left'},

				{label: '出库重量', prop: 'channelWeight', width: 80},
				{label: '数量', prop: 'quantityOfOrdered', width: 60},

				{label: '产品信息', prop: 'orderItems', width: 300, align: 'left'},

				{label: '成本(￥)', prop: 'costPrice', width: 80},
				{label: '利润(￥)', prop: 'profitPrice', width: 80},
				{label: '运费', prop: 'channelShipping', width: 80},

				{label: '国家', prop: 'countryName'},
				{label: '平台', prop: 'sourceclass'},
				{label: '店铺', prop: 'countryMarks'},
				
				{label: '订单状态', prop: 'orderStatus', width: 80},
				{label: '地址状态', prop: 'addressStatus', width: 80},
				{label: '国际运单号', prop: 'orderChannelsNumber', width: 260},
				{label: '国际运单状态', prop: 'orderChannels', width: 130},
				{label: '国内运单', prop: 'purchases', width: 260},
				{label: '采购需求状态', prop: 'purchaseDemandStatus', width: 60},
				{label: '采购预估状态', prop: 'purchaseEstimated'},
				{label: '物流预估状态', prop: 'logisticsEstimated'},
				{label: '物流预估费用', prop: 'logisticsCostEstimate'},
			],
			uploading: false,
			activeHeader: [],
			selectHeader: [],
			// shop: [{ value: "1", label: "店铺" }],
			domestic: Object.freeze([
				{ label: '已采购', value: '2' },
				{ label: '已发货', value: '3' },
				{ label: '已签收', value: '4' },
				{ label: '退货', value: '5' },
				{ label: '在途', value: '6' },
				{ label: '揽收', value: '7' },
				{ label: '疑难', value: '8' },
				{ label: '退签', value: '9' },
				{ label: '派件', value: '10' },
				{ label: '退回', value: '11' },
				{ label: '转投', value: '12' },
				{ label: '待清关', value: '13' },
				{ label: '清关中', value: '14' },
				{ label: '已清关', value: '15' },
				{ label: '清关异常', value: '16' },
				{ label: '拒签', value: '17' },
				{ label: '清关', value: '18' },
				{ label: '已下单', value: '101' },
				{ label: '待揽收', value: '102' },
				{ label: '已揽收', value: '103' },
				{ label: '到达派件城市', value: '1001' },
				{ label: '干线', value: '1002' },
				{ label: '转递', value: '1003' },
				{ label: '投柜或驿站', value: '501' },
				{ label: '本人签收', value: '301' },
				{ label: '派件异常后签收', value: '302' },
				{ label: '代签', value: '303' },
				{ label: '投柜或站签收', value: '304' },
				{ label: '已销单', value: '401' },
				{ label: '超时未签收', value: '201' },
				{ label: '超时未更新', value: '202' },
				{ label: '拒收', value: '203' },
				{ label: '派件异常', value: '204' },
				{ label: '柜或驿站超时未取', value: '205' },
				{ label: '无法联系', value: '206' },
				{ label: '超区', value: '207' },
				{ label: '滞留', value: '208' },
				{ label: '破损', value: '209' },
				{ label: '销单', value: '210' },
			]),


			domestic1: Object.freeze([
				{ label: '未发货', value: '0' },
				{ label: '已发货', value: '4' },
				{ label: '已签收', value: '5' },
				{ label: '在途', value: '6' },
				{ label: '揽收', value: '7' },
				{ label: '疑难', value: '8' },
				{ label: '退签', value: '9' },
				{ label: '派件', value: '10' },
				{ label: '退回', value: '11' },
				{ label: '转投', value: '12' },
				{ label: '待清关', value: '13' },
				{ label: '清关中', value: '14' },
				{ label: '已清关', value: '15' },
				{ label: '清关异常', value: '16' },
				{ label: '拒签', value: '17' },
				{ label: '清关', value: '18' },
				{ label: '已下单', value: '101' },
				{ label: '待揽收', value: '102' },
				{ label: '已揽收', value: '103' },
				{ label: '到达派件城市', value: '1001' },
				{ label: '干线', value: '1002' },
				{ label: '转递', value: '1003' },
				{ label: '投柜或驿站', value: '501' },
				{ label: '本人签收', value: '301' },
				{ label: '派件异常后签收', value: '302' },
				{ label: '代签', value: '303' },
				{ label: '投柜或站签收', value: '304' },
				{ label: '已销单', value: '401' },
				{ label: '超时未签收', value: '201' },
				{ label: '超时未更新', value: '202' },
				{ label: '拒收', value: '203' },
				{ label: '派件异常', value: '204' },
				{ label: '柜或驿站超时未取', value: '205' },
				{ label: '无法联系', value: '206' },
				{ label: '超区', value: '207' },
				{ label: '滞留', value: '208' },
				{ label: '破损', value: '209' },
				{ label: '销单', value: '210' },
			]),

			logisticsStatus: Object.freeze([
				{ label: '查询不到', value: '查询不到' },
				{ label: '收到信息', value: '收到信息' },
				{ label: '运输途中', value: '运输途中' },
				{ label: '运输过久', value: '运输过久' },
				{ label: '到达待取', value: '到达待取' },
				{ label: '派送途中', value: '派送途中' },
				{ label: '投递失败', value: '投递失败' },
				{ label: '成功签收', value: '成功签收' },
				{ label: '可能异常', value: '可能异常' }
			]),

			// [
			//     //国内物流
			//     {
			//         value: "1",
			//         label: "已采购",
			//     },
			//     {
			//         value: "2",
			//         label: "已发货",
			//     },
			//     {
			//         value: "3",
			//         label: "已签收",
			//     },
			//     {
			//         value: "4",
			//         label: "退货",
			//     },
			//     {
			//         value: "1",
			//         label: "已采购",
			//     },
			//     {
			//         value: "2",
			//         label: "已发货",
			//     },
			//     {
			//         value: "3",
			//         label: "已签收",
			//     },
			//     {
			//         value: "4",
			//         label: "退货",
			//     },
			//     {
			//         value: "1",
			//         label: "已采购",
			//     },
			//     {
			//         value: "2",
			//         label: "已发货",
			//     },
			//     {
			//         value: "3",
			//         label: "已签收",
			//     },
			//     {
			//         value: "4",
			//         label: "退货",
			//     },
			// ],
			// 亚马逊订单状态
			Ymxpurchase: [
				{
					value: '1',
					label: '已取消',
				},
				{
					value: '2',
					label: '等待中',
				},
				{
					value: '3',
					label: '未发货',
				},
				{
					value: '4',
					label: '已发货',
				},
				{
					value: '5',
					label: '已退款',
				},
			],
			//采购需求状态
			demandValue: [
				{
					value: '1',
					label: '未完成',
				},
				{
					value: '2',
					label: '已完成',
				},
			],
			//采购状态
			purchaseValue: [
				{
					value: '未采购',
					label: '未采购',
				},
				{
					value: '已采购',
					label: '已采购',
				},
			],
			ruleForm: {
				shopvalue: '', //选择店铺
				Ymxvalue: '', //亚马逊订单状态
				domesticvalue: '', //国内发货状态
				domesticLogisticsStatus: '', //国内物流状态
				purchaseEstimated: '', //采购费用预估状态
				logisticsEstimated: '', //物流费用预估状态
				addressStatus: '', //地址状态
				channelStatus: '', // 国际发货状态
				internationalLogisticsStatus: '', // 国际物流状态
				countryMark: '', // 国家
				starttime: '', //开始时间
				endtime: '', //结束时间
				demandValue: '', //选择采购需求状态
				purchaseValue: '', //选择采购状态

				internalConveyNumber: '', //国内运单
				conveyNumber: '', //国际运单

				resource1: '',
				resource2: '',
				resource3: '',
				resource4: '',
				systemSku: '',
				sku: '',
			},
			currentpage: 1,
			pagesize: 20,
			input: '',
			searchdata: '',
			size: 20,
			sellerIds: '',
			disabledInput: '',
			disabledInput2: '',
			disabledInput3: '',
			disabledInput4: '',
			arr: '',
			arr1: '',
			arr2: '',
			arr3: '',
			arr4: '',
			arr5: '',
			orderStatus: '',
			shopIds: [],
			loading: false,
			// 判断同步订单按钮是否显示
			show: '',
			dialog: false,
			options: [],
			value: '',
			value6: '',
			purchaseDemandStatus: '',
			purchaseStatus: '',
			str: '',
			strSeller: '',
			downloadDialog: false,
			downloadOptions: [],
			downLoadValue: '',
			syncIstrue: false,
			arr6: [],
			arr7: [],
			value6: '',
			value7: '',
			companyId: '',
			rate: [],
			errorList: [],
			uploadWaybillDialog: false,
			listTableWaybill: [],
			identifyLoading: false,
			waybillType: '1',
			waybillPage: 1,
			waybillSize: 20,
			waybillTotal: 0,
			uploadWaybillShop: {},
			companyInfo: '',
			optionsUpload: [],
			multipleSelection: [],
			colorList1: [],
			colorList2: [],
			colorList3: [],
			colorList4: {},
			colordisabled: true,

			purchaseMark: '',
			channelMark: '',
			orderMark: '',
			orderType: '',
			loadingStatus: false,
			originalImg: '',
			originalVisible: false,
			radioTime: '',
			rid: '',
			popoverText: '查询中...',
			popoverStatus: true,
			popoverInfo: null,
			popoverDomesticOrderStatus: Object.freeze({
				0: '在途',
				1: '揽收',
				2: '疑难',
				3: '签收',
				4: '退签',
				5: '派件',
				6: '退回',
				7: '转投',
				10: '待清关',
				11: '清关中',
				12: '已清关',
				13: '清关异常',
				14: '拒签',
				100: ''
			}),
			domesticOrderStatus: Object.freeze({
				1: { title: '待采购', color: '#f04b22' },
				2: { title: '已采购', color: '#1677b3' },
				3: { title: '已发货', color: '#12a182' },
				4: { title: '已签收', color: '#835e1d' },
				5: { title: '退货', color: '#cc163a' },
				6: { title: '在途', color: '#feba07' },
				7: { title: '揽收', color: '#f97d1c' },
				8: { title: '疑难', color: '#ffa60f' },
				9: { title: '退签', color: '#de1c31' },
				10: { title: '派件', color: '#b7511d' },
				11: { title: '退回', color: '#ec4e8a' },
				12: { title: '转投', color: '#f09c5a' },
				13: { title: '待清关', color: '#619ac3' },
				14: { title: '清关中', color: '#2775b6' },
				15: { title: '已清关', color: '#22a2c3' },
				16: { title: '清关异常', color: '#ef498b' },
				17: { title: '拒签', color: '#c21f30' },
				18: { title: '清关', color: '#c21f30' },
				101: { title: '已下单', color: '#c21f30' },
				102: { title: '待揽收', color: '#c21f30' },
				103: { title: '已揽收', color: '#c21f30' },
				1001: { title: '到达派件城市', color: '#c21f30' },
				1002: { title: '干线', color: '#c21f30' },
				1003: { title: '转递', color: '#c21f30' },
				501: { title: '投柜或驿站', color: '#c21f30' },
				301: { title: '本人签收', color: '#c21f30' },
				302: { title: '派件异常后签收', color: '#c21f30' },
				303: { title: '代签', color: '#c21f30' },
				304: { title: '投柜或站签收', color: '#c21f30' },
				401: { title: '已销单', color: '#c21f30' },
				201: { title: '超时未签收', color: '#c21f30' },
				202: { title: '超时未更新', color: '#c21f30' },
				203: { title: '拒收', color: '#c21f30' },
				204: { title: '派件异常', color: '#c21f30' },
				205: { title: '柜或驿站超时未取', color: '#c21f30' },
				206: { title: '无法联系', color: '#c21f30' },
				207: { title: '超区', color: '#c21f30' },
				208: { title: '滞留', color: '#c21f30' },
				209: { title: '破损', color: '#c21f30' },
				210: { title: '销单', color: '#c21f30' },
			}),
			internationalOrderStatus: Object.freeze({
				0: { title: '未发货', color: 'blue' },
				1: { title: '作废', color: 'red' },
				2: { title: '未发货', color: 'blue' },
				3: { title: '未发货', color: 'blue' },
				4: { title: '已发货', color: 'green' },
				5: { title: '已签收', color: '#cc163a' },
				6: { title: '在途', color: '#feba07' },
				7: { title: '揽收', color: '#f97d1c' },
				8: { title: '疑难', color: '#ffa60f' },
				9: { title: '退签', color: '#de1c31' },
				10: { title: '派件', color: '#b7511d' },
				11: { title: '退回', color: '#ec4e8a' },
				12: { title: '转投', color: '#f09c5a' },
				13: { title: '待清关', color: '#619ac3' },
				14: { title: '清关中', color: '#2775b6' },
				15: { title: '已清关', color: '#22a2c3' },
				16: { title: '清关异常', color: '#ef498b' },
				17: { title: '拒签', color: '#c21f30' },
				18: { title: '清关', color: '#c21f30' },
				101: { title: '已下单', color: '#c21f30' },
				102: { title: '待揽收', color: '#c21f30' },
				103: { title: '已揽收', color: '#c21f30' },
				1001: { title: '到达派件城市', color: '#c21f30' },
				1002: { title: '干线', color: '#c21f30' },
				1003: { title: '转递', color: '#c21f30' },
				501: { title: '投柜或驿站', color: '#c21f30' },
				301: { title: '本人签收', color: '#c21f30' },
				302: { title: '派件异常后签收', color: '#c21f30' },
				303: { title: '代签', color: '#c21f30' },
				304: { title: '投柜或站签收', color: '#c21f30' },
				401: { title: '已销单', color: '#c21f30' },
				201: { title: '超时未签收', color: '#c21f30' },
				202: { title: '超时未更新', color: '#c21f30' },
				203: { title: '拒收', color: '#c21f30' },
				204: { title: '派件异常', color: '#c21f30' },
				205: { title: '柜或驿站超时未取', color: '#c21f30' },
				206: { title: '无法联系', color: '#c21f30' },
				207: { title: '超区', color: '#c21f30' },
				208: { title: '滞留', color: '#c21f30' },
				209: { title: '破损', color: '#c21f30' },
				210: { title: '销单', color: '#c21f30' },
			}),
			listChannel: [],
			platform: [
				{ "sellerType": 1, "itemTypeName": "Amazon" }, { "sellerType": 2, "itemTypeName": "Shopify" }, { "sellerType": 5, "itemTypeName": "Shoplazza" }, { "sellerType": 7, "itemTypeName": "Shopline" }
			],
			platforms: [],
			//上传订单弹框中选择平台所需要的id记录变量
			sellerTypeID: '',
			//上传订单弹框中控制表格的loading显示隐藏变量
			loadingTable: false,
			exportBool: false,
			exportTime: [],
			exportVersion: '1', // 导出版本：1-标准版，2-优化版
			exportShopList: [], // 导出可选店铺列表
			exportLoading: false, // 导出loading状态
			// 店铺订单导出相关变量
			shopExportTime: [], // 店铺导出时间范围
			shopExportId: '', // 店铺导出选中的店铺ID
			shopExportLoading: false, // 店铺导出loading状态
			procurementBool: false,
			procurementData: '',
			procurementloading: false,
			listRemarkStandard: [],
			listRemarkStandardvalue: '',
			procurementType: '一次采购',
			addSkuTable: [],
			setSellerType: new Set([]),
			setSellerId: new Set([]),
			disabledSku: true,
			activities: [],
			listCountry: [],
			btnSetLoading: false,
			dialogSetFormVisible: false,
			purchaseCostEstimate: 0,
			logisticsCostEstimate: 0,
			showFilter: true,
			inputList: '',
			ozonfinancialTypeMap:{
				agency_fee_ozon: 'Ozon代理佣金',
				international_delivery_services: '国际配送服务',
				partial_compensation_to_buyers: '给买家的部分赔偿',
			},
			designate_users: [
				"郭宏伟", "范牧西", "高景芳",
				"杜晓伟", "白锦蕙", "常洪旭", "段雅楠", "赵永芯",
				"王永薇", "郭爽", "李淑秀",
				"李宏丽", "李跃波",
				"白锦蕙", "光紫光", "姜赵管", "刘孩呈", "杨景", "周杰",
				"降泽源", "同乐", "宋子阳"
			],
		}
	},
	computed: {
		tableHeader(){
			// 按照allTableHeader顺序排
			return this.allTableHeader
				.filter(h => this.activeHeader.includes(h.prop))
				.map(h => ({ ...h }))
		}
	},
	watch: {
		// 监听 arr4 的变化，更新导出店铺列表
		arr4: {
			handler(newVal) {
				if (newVal && newVal.length > 0) {
					// 按 sellerInfoId 聚合，去除重复的店铺
					const shopMap = new Map();
					newVal.forEach(shop => {
						if (shop.sellerInfoId && !shopMap.has(shop.sellerInfoId)) {
							// 去掉国家后缀，提取纯店铺名称
							let shopName = shop.shopName;
							// 移括号内容 "(Amazon)(美国)" 等
							shopName = shopName.replace(/\([^)]*\)$/g, '').trim();
							shopMap.set(shop.sellerInfoId, {
								...shop,
								shopName: shopName
							});
						}
					});
					this.exportShopList = Array.from(shopMap.values());
				}
			},
			deep: true,
			immediate: true
		}
	},
	created() {
		const cache = localStorage.getItem('order_table_column_width')
		if (cache) {
			const widthMap = JSON.parse(cache)
			this.allTableHeader.forEach(h => {
				if (widthMap[h.prop]) {
					h.width = widthMap[h.prop]
				}
			})
		}
		let activeHeader = [];
		if (localStorage.getItem('FBMOrderHeader')) {
			activeHeader = JSON.parse(localStorage.getItem('FBMOrderHeader'));
		} else {
			// 默认显示部分列
			for(let i = 0; i < this.allTableHeader.length; i++){
				activeHeader.push(this.allTableHeader[i].prop);
			}
		}
		this.activeHeader = activeHeader;
		this.selectHeader = activeHeader;
		this.str = JSON.parse(localStorage.getItem('role'))
		this.strSeller = JSON.parse(localStorage.getItem('sellerInfo'))
		this.show = this.str.system
		this.state = this.str.system
		this.companyId = this.str.company_id
		this.rid = this.str.rid
		this.getThisMonth()
		const API = Baseurl + '/purchaseController/selectItemList'
		const paramsData = {
			"itemCode": "HYXUN0000014"
		}
		ajaxPost(API, paramsData)
			.then((res) => {
				if (res.data.code === 200) {
					this.platforms = res.data.data
				} else {
					this.platform = []
					this.$message.error(res.data.data)
				}
				this.sellerTypeID = this.platforms[0].sellerType;

				// this.handleUpload(this.sellerTypeID);
			})
		this.init()
		this.getRate()
		this.getCompanyInfo()

		this.orderTag()
		this.domesticTag()
		this.internationalTag()
		this.ordertypeTag()
		this.exportShow()
		this.getListCountry()
		this.platform = []
		if (this.str.type === 3) {
			this.getItemList();
		}
		this.getListReamrkStandard()
		// this.handleUpload(this.sellerTypeID);
	},
	methods: {
		saveHeader(){
			this.activeHeader = this.selectHeader;
			localStorage.setItem('FBMOrderHeader', JSON.stringify(this.activeHeader));
			this.visibleSetting = false;
			this.$nextTick(() => {
				this.$refs.orderTable.doLayout()
			})

		},
		handleHeaderDragend(newWidth, oldWidth, column, event) {
			if (!column.property) return

			// 找到对应列
			const item = this.allTableHeader.find(
				h => h.prop === column.property
			)
			if (item) {
				item.width = newWidth
				this.saveColumnWidth()
			}
		},
		async handleFreightExcel(event) {
			const file = event.target.files[0]
			if (!file || this.uploading) return

			this.uploading = true
			try {
				const buffer = await new Promise((resolve, reject) => {
					const reader = new FileReader()
					reader.onload = () => resolve(reader.result)
					reader.onerror = () => reject(new Error('文件读取失败'))
					reader.readAsArrayBuffer(file)
				})

				const workbook = XLSX.read(buffer, { type: 'array' })
				const sheet = workbook.Sheets[workbook.SheetNames[0]]
				const table = XLSX.utils.sheet_to_json(sheet, {
					header: 1,
					defval: '',
					blankrows: false
				})

				if (table.length < 2) {
					throw new Error('Excel 中没有数据')
				}

				const headers = table[0].map(value => String(value).trim())
				const required = ['运单号', '长', '宽', '高', '实重', '标记']
				required.forEach(name => {
					if (headers.indexOf(name) === -1) {
						throw new Error(`Excel 缺少表头：${name}`)
					}
				})

				const getValue = (row, name) => {
					const value = row[headers.indexOf(name)]
					return value == null ? '' : String(value).trim()
				}

				const rows = table.slice(1)
					.filter(row => row.some(value => String(value == null ? '' : value).trim()))
					.map((row, index) => {
						const item = {
							conveyNumber: getValue(row, '运单号'),
							lengthCm: getValue(row, '长'),
							widthCm: getValue(row, '宽'),
							heightCm: getValue(row, '高'),
							weightKg: getValue(row, '实重'),
							mark: getValue(row, '标记')
						}

						if (!item.conveyNumber) {
							throw new Error(`第 ${index + 1} 条缺少运单号`)
						}

						['lengthCm', 'widthCm', 'heightCm', 'weightKg'].forEach(key => {
							if (!item[key] || !Number.isFinite(Number(item[key])) ||
								Number(item[key]) <= 0) {
								throw new Error(`第 ${index + 1} 条的 ${key} 必须大于 0`)
							}
						})

						if (!['普货', '带电', '敏感货'].includes(item.mark)) {
							throw new Error(`第 ${index + 1} 条的标记不正确`)
						}

						return item
					})


				// rows 是解析后的 JSON 数组，直接上传
				const response = await ajaxPost(Baseurl + '/freight/samples/import', rows)
				const result = response.data.data

				this.$message[result.failed ? 'warning' : 'success'](
					`导入完成：成功 ${result.success} 条，失败 ${result.failed} 条`
				)
				if (result.failed) {
					console.table(result.results.filter(item => item.status !== 'SUCCESS'))
				}
			} catch (error) {
				this.$message.error(error.message || '导入失败')
			} finally {
				this.uploading = false
				event.target.value = ''
			}
		},
		saveColumnWidth() {
			const widthMap = {}
			this.allTableHeader.forEach(h => {
			if (h.prop && h.width) {
				widthMap[h.prop] = h.width
			}
			})
			localStorage.setItem(
				'order_table_column_width',
				JSON.stringify(widthMap)
			)
		},
		// 时间转换
		timeConversion(item) {
			const date = new Date(item);
			const year = date.getFullYear();
			const month = (date.getMonth() + 1).toString().padStart(2, '0');
			const day = date.getDate().toString().padStart(2, '0');
			const hour = date.getHours().toString().padStart(2, '0');
			const minute = date.getMinutes().toString().padStart(2, '0');
			const seconds = date.getSeconds().toString().padStart(2, '0');
			const formattedTime = `${year}/${month}/${day} ${hour}:${minute}:${seconds}`
			return formattedTime
		},
		getRemainingTime(latestShipDate) {
			if (!latestShipDate) return '';

			const latestDate = new Date(latestShipDate); // 最后发货时间
			const currentTime = new Date(); // 当前时间
			const timeDiff = latestDate - currentTime; // 时间差（以毫秒为单位）

			if (timeDiff <= 0) {
				return ''; // 如果为负值或0，则返回空字符串，显示 "已超时"
			}

			// 计算天、时、分
			const days = Math.floor(timeDiff / (1000 * 60 * 60 * 24));
			const hours = Math.floor((timeDiff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
			const minutes = Math.floor((timeDiff % (1000 * 60 * 60)) / (1000 * 60));

			let timeText = '';
			if (days > 0) timeText += `${days} 天 `;
			if (hours > 0) timeText += `${hours} 时 `;
			if (minutes > 0) timeText += `${minutes} 分`;

			return timeText.trim(); // 返回格式化后的时间差值
		},
		copyTextToClipboard(textToCopy) {
			console.log(textToCopy);
			// 使用 Clipboard API 复制文本
			navigator.clipboard.writeText(textToCopy)
				.then(() => {
					// 复制成功后的处理
					this.$message.success('文本已复制到剪贴板');
				})
				.catch(err => {
					// 复制失败时的处理
					console.error('复制失败:', err);
					this.$message.error('复制失败');
				});
		},
		getListCountry() {
			const API =
				Baseurl +
				'logisticsConfigurationController/selectLogisticsCountryList'
			ajaxPost(API).then((res) => {
				const { code, data } = res.data
				if (code === 200) {
					this.listCountry = data
				}
			})
		},
		popoverShows(orderId) {
			ajaxPost(Baseurl + 'logisticsController/getOrderOperateLog', { orderId }).then((res) => {
				if (res.data.code == 200) {
					this.activities = res.data.data
				}
			})
		},
		showSku() {
			this.$refs.skuAdd.init()
		},
		getListReamrkStandard() {
			const API =
				Baseurl +
				'purchaseRemarksStandardController/selectPurchaseRemarksStandardList'
			ajaxPost(API).then((res) => {
				const { code, data } = res.data
				if (code === 200) {
					this.listRemarkStandard = data
				}
			})
		},
		procurementCancel() {
			this.procurementBool = false
			this.procurementData = ''
			this.listRemarkStandardvalue = ''
		},
		handleProcurement() {
			this.procurementType = '一次采购'
			this.multipleSelection.map(item => {
				var purchaseDemands = item.purchaseDemands
				if (purchaseDemands.length > 0) {
					for (var i = 0; i < purchaseDemands.length; i++) {
						var purchaseItems = purchaseDemands[i].purchaseItems
						if (purchaseItems.length > 0) {
							this.procurementType = '二次采购'
						}
					}
				}
			})
			this.procurementBool = true
		},
		submitProcurement() {
			if (this.procurementData == '') {
				this.$message.error("请输入采购需求！")
				return
			}
			let bool = false
			this.multipleSelection.map(item => {
				if (item.money == null) bool = true
			})
			if (bool) {
				this.$message.error("当前订单买家未下单，无法采购!")
				return
			}
			var str = JSON.parse(localStorage.getItem('role'))
			let params = []
			this.multipleSelection.map(item => {
				let productInfos = []
				for (var i in item.orderItems) {
					productInfos.push({
						title: item.orderItems[i]['title'] || '',
						sku: item.orderItems[i]['sellerSKU'] || '',
						imageUrl: item.orderItems[i]['imageUrl'] || '',
						sourceLink: item.orderItems[i]['saleLink'] || '',
						quantityOrdered: item.orderItems[i]['quantityOrdered'] || '',
						itemAmount: item.orderItems[i]['itemAmount'] || '',
						itemCurrencyCode: item.orderItems[i]['itemCurrencyCode'] || '',
					})
				}
				let param = {
					orderId: item.id,
					amazonOrderId: item.amazonOrderId,
					amountReceived: item.money.amountChina,
					purchaseDate: item.purchaseDate,
					purchaseDemand: this.procurementData,
					shopName: item.countryMarks.countryName,
					shopId: item.countrySellerId,
					stuffId: str.rid,
					stock: item.quantityOfOrdered,
					type: this.procurementType,
					companyId: str.company_id,
					productInfos: productInfos,
					rid: str.rid,
					logisticsStatus: item.logisticsStatus,
				}
				params.push(param)
			})

			this.procurementloading = true
			ajaxPost(
				Baseurl + 'purchaseDemandController/batchInsertPurchaseDemand',
				params
			).then((res) => {
				const { code, data } = res.data
				if (code === 200) {
					this.$message.success('已生成采购需求！')
					this.procurementData = ''
					this.listRemarkStandardvalue = ''
					this.$emit('edit')
					this.Search()
					this.procurementBool = false
				} else {
					this.$alert(
						'上一次采购需求流程未完成无法添加新的采购需求采购需求',
						'采购提示'
					)
				}
				this.procurementloading = false
			})
		},
		changeStandard(content) {
			this.procurementData = content
		},
		//上传运单按钮点击事件
		shangchuan() {
			this.uploadWaybillDialog = true
			this.handleUpload(this.sellerTypeID);
		},
		getItemList() {
			const API = Baseurl + '/sellerController/selectSellerTypeByRid'
			const paramsData = {
				"rid": this.rid
			}
			ajaxPost(API, paramsData)
				.then((res) => {
					if (res.data.code === 200) {
						this.platform = res.data.data
					} else {
						this.platform = []
						this.$message.error(res.data.data)
					}
					this.sellerTypeID = this.platform[0]?.sellerType;
					// this.handleUpload(this.sellerTypeID);
				})
		},
		logisticsList(list) {
			list.forEach((item) => {
				// 三态
				if (item.type == 1) {
					if (
						item.channelWay == '三态免泡普货专线(大货)' ||
						'免泡大货HB' ||
						'三态服装专线' ||
						'三态物理专线（普货）'
					) {
						item.channelWayEn = 'SFC Global Line-no battery'
					} else {
						item.channelWayEn = 'SFC Global Line-with battery'
					}
				} else if (item.type == 12) {
					item.channelWayEn = 'USPS First Class'
				} else if (item.type == 3) {
					// 燕文
					if (item.channelWay == '燕文专线追踪小包-普货') {
						item.channelWayEn = 'Yanwen Air Track Packet General'
					} else if (item.channelWay == '燕文专线追踪小包-特货') {
						item.channelWayEn = 'Yanwen Air Track Packet Special'
					} else {
						item.channelWayEn = ''
					}
				} else if (item.type == 2 || 7 || 10) {
					// 云途
					if (item.channelWay == '云途全球专线挂号（特惠普货）') {
						item.channelWayEn =
							'YunExpress Global Direct line non Battery-Tracked'
					} else if (
						item.channelWay == '云途全球专线挂号（特惠带电）'
					) {
						item.channelWayEn =
							'YunExpress Global Direct line with Battery-Tracked'
					} else {
						item.channelWayEn = ''
					}
				} else if (item.type == 6) {
					// 递四方
					this.DiSiFang.forEach((elem) => {
						if (item.channelWay == elem.label) {
							item.channelWayEn = elem.value
						} else {
							item.channelWayEn = ''
						}
					})
				}
			})
		},
		channelInp(val) {
			let R = /[\u4E00-\u9FA5]/i
			if (R.test(val)) {
				this.$message.error('请检查输入的运输方式，禁止输入汉字！')
				return
			}
		},
		OneOperation() {
			if (this.waybillType == '2') {
				if (this.listTableWaybill.length != 0) {
					let sleVal = this.listTableWaybill[0].channelName
					if (sleVal != '') {
						this.listTableWaybill.forEach((item) => {
							item.channelName = sleVal
						})
					} else {
						this.$message.info('一键操作前请为表格第一行选择！')
					}
				}
			} else {
				if (this.listTableWaybill.length != 0) {
					if (this.sleValue != '') {
						this.listTableWaybill.forEach((item) => {
							if (item.channelName === this.sleName) {
								item.channelWayEn = this.sleValue
							}
						})
					} else {
						this.$message.info('请选择渠道信息！')
					}
				}
			}
		},
		async identifyCarrier() {
			// 检查是否有数据
			if (this.listTableWaybill.length === 0) {
				this.$message.warning('请先获取转单号数据！')
				return
			}

			this.identifyLoading = true

			try {
				// 获取所有转单号
				const trackingNumbers = this.listTableWaybill
					.map(item => item.transferOrderNumber)
					.filter(num => num && num.trim() !== '')

				if (trackingNumbers.length === 0) {
					this.$message.warning('没有有效的转单号！')
					this.identifyLoading = false
					return
				}

				// 构建请求参数
				const params = trackingNumbers.map(number => ({
					number: number,
					carrier: null
				}))

				// 调用API
				const API = Baseurl + 'track17Controller/gettrackinfo'

				// 指数退避重试机制：5秒 -> 10秒 -> 20秒 -> 40秒 -> 60秒
				const retryDelays = [5000, 10000, 20000, 40000, 60000] // 毫秒
				let currentParams = params
				let totalSuccessCount = 0
				let totalRejectedCount = 0
				let hasRejected = true
				let retryCount = 0

				// 首次查询
				let response = await ajaxPost(API, currentParams)

				if (response.data.code === 200) {
					const trackData = response.data.data

					// 处理accepted的结果
					if (trackData.data && trackData.data.accepted) {
						totalSuccessCount += trackData.data.accepted.length
						this.processCarrierResult(response.data)
					}

					// 检查是否有rejected项
					if (trackData.data && trackData.data.rejected && trackData.data.rejected.length > 0) {
						totalRejectedCount = trackData.data.rejected.length
						currentParams = trackData.data.rejected.map(item => ({
							number: item.number,
							carrier: null
						}))

						// 开始指数退避重试
						for (let i = 0; i < retryDelays.length && hasRejected; i++) {
							retryCount++
							const delay = retryDelays[i]
							const delaySeconds = delay / 1000

							this.$message.warning(`发现 ${totalRejectedCount} 个未识别的转单号，${delaySeconds} 秒后第 ${retryCount} 次重试...`)

							// 延迟等待
							await new Promise(resolve => setTimeout(resolve, delay))

							// 重试查询rejected的转单号
							response = await ajaxPost(API, currentParams)

							if (response.data.code === 200) {
								const retryTrackData = response.data.data

								// 处理新accepted的结果
								if (retryTrackData.data && retryTrackData.data.accepted) {
									totalSuccessCount += retryTrackData.data.accepted.length
									this.processCarrierResult(response.data)
								}

								// 检查是否还有rejected
								if (retryTrackData.data && retryTrackData.data.rejected && retryTrackData.data.rejected.length > 0) {
									totalRejectedCount = retryTrackData.data.rejected.length
									currentParams = retryTrackData.data.rejected.map(item => ({
										number: item.number,
										carrier: null
									}))
								} else {
									hasRejected = false
								}
							} else {
								this.$message.error(`第 ${retryCount} 次重试失败：` + response.data.message)
							}
						}

						// 如果重试完成还有rejected，显示提示
						if (hasRejected && totalRejectedCount > 0) {
							this.$message.warning(`仍有 ${totalRejectedCount} 个转单号未能识别，可能需要稍后手动重试`)
						} else {
							this.$message.success(`重试完成！共成功识别 ${totalSuccessCount} 个运输渠道商`)
						}
					} else {
						this.$message.success(`成功识别 ${totalSuccessCount} 个运输渠道商`)
					}
				} else {
					this.$message.error('识别失败：' + response.data.message)
				}
			} catch (error) {
				console.error('识别运输渠道商失败：', error)
				this.$message.error('识别失败，请稍后重试')
			} finally {
				this.identifyLoading = false
			}
		},
		processCarrierResult(responseData) {
			if (!responseData.data || !responseData.data.data) {
				this.$message.warning('未获取到渠道信息')
				return
			}

			const accepted = responseData.data.data.accepted || []
			let successCount = 0

			// 遍历返回的结果，更新表格中的渠道名称
			accepted.forEach(item => {
				if (item.track_info && item.track_info.tracking && item.track_info.tracking.providers) {
					const provider = item.track_info.tracking.providers[0]
					if (provider && provider.provider) {
						const carrierName = provider.provider.name
						const trackingNumber = item.number

						// 在表格中找到对应的转单号并更新渠道名称
						const tableRow = this.listTableWaybill.find(row => row.transferOrderNumber === trackingNumber)
						if (tableRow) {
							tableRow.channelName = carrierName
							successCount++
						}
					}
				}
			})

			if (successCount > 0) {
				this.$message.success(`成功识别 ${successCount} 个运输渠道商`)
			} else {
				this.$message.warning('未能识别出运输渠道商')
			}
		},
		noTreatmentRequired() {
			let that = this
			if (!checkedList.length) {
				this.$alert('请至少勾选一件产品！', '提示', {
					confirmButtonText: '确定',
				})
			} else {
				let params = {
					ids:[]
				}
				checkedList.forEach((item)=>{
					params.ids.push(item.id)
				})
				ajaxPost(
					Baseurl + 'orderChannel/updateConveyStatus',
					params
				).then((res) => {
					if (res.data.code == 200) {
						that.$message({
							type: 'success',
							message: '操作成功!',
						})
						that.uploadWaybillList()
					}
				})
			}
		},
		hanleChange(val) {
			this.listTableWaybill.forEach(item => {
				if (item.channelWayEn == val) {
					this.sleValue = item.channelWayEn
					this.sleName = item.channelName
				}
			})
		},
		handleCommand1(val) {
			var obj = {
				orderInfos: this.multipleSelection,
				orderMarkId: val,
			}
			ajaxPost(Baseurl + 'orderController/updateOrderMark', obj).then(
				(res) => {
					if (res.data.code == 200) {
						this.init()
					} else {
						this.$message.error(res.data.data)
					}
				}
			)
		},
		handleCommand2(val) {
			var obj = {
				orderInfos: this.multipleSelection,
				orderMarkId: val,
			}
			ajaxPost(
				Baseurl + 'orderController/insertOrderPurchaseMark',
				obj
			).then((res) => {
				if (res.data.code == 200) {
					this.init()
				} else {
					this.$message.error(res.data.data)
				}
			})
		},
		handleCommand3(val) {
			var obj = {
				orderInfos: this.multipleSelection,
				orderMarkId: val,
			}
			ajaxPost(
				Baseurl + 'orderController/insertOrderChannelMark',
				obj
			).then((res) => {
				if (res.data.code == 200) {
					this.init()
				} else {
					this.$message.error(res.data.data)
				}
			})
		},
		radiochange1(val) {
			this.orderMark = val
			this.Search()
		},
		radiochange2(val) {
			this.purchaseMark = val
			this.Search()
		},
		radiochange3(val) {
			this.channelMark = val
			this.Search()
		},
		radiochange4(val) {
			this.orderType = val
			this.Search()
		},
		radioChangeTime(val) {
			// 今天的时间和时间戳
			const nowDate = new Date()
			const nowTimeStamp = nowDate.getTime()
			// 上一天的时间戳
			const beforeTimeStamp = nowTimeStamp - 3600 * 1000 * 24
			let startStamp = ''
			let endStamp = ''
			switch (val) {
				case '3-7':
					startStamp = 3600 * 1000 * 24 * 6
					endStamp = 3600 * 1000 * 24 * 3
					break
				case '8-11':
					startStamp = 3600 * 1000 * 24 * 10
					endStamp = 3600 * 1000 * 24 * 8
					break
				case '25':
					endStamp = 3600 * 1000 * 24 * 25
					break
				default:
					this.ruleForm.starttime = ''
					break
			}
			const endData = new Date(beforeTimeStamp - endStamp)
			const endYear = endData.getFullYear()
			const endMonth = endData.getMonth() + 1
			const endDay = endData.getDate()
			this.ruleForm.endtime = `${endYear}-${endMonth}-${endDay} 23:59:59`

			const startData = new Date(beforeTimeStamp - startStamp)
			const startYear = startData.getFullYear()
			const startMonth = startData.getMonth() + 1
			const startDay = startData.getDate()
			this.ruleForm.starttime = `${startYear}-${startMonth}-${startDay} 00:00:00`
			if (val === '25') this.ruleForm.starttime = ''
			this.Search()
		},
		handleSelectionChange(val) {
			this.setSellerType.clear()
			this.setSellerId.clear()
			val.map(item => {
				this.setSellerType.add(item.seller.sellerType)
				this.setSellerId.add(item.seller.sellerId)
			})
			if (this.setSellerType.size == 1 && this.setSellerId.size == 1) {
				this.disabledSku = false
			} else {
				this.disabledSku = true
			}
			this.multipleSelection = val
			this.addSkuTable = JSON.parse(JSON.stringify(val))
			if (this.multipleSelection.length == 0) {
				this.colordisabled = true
			} else {
				this.colordisabled = false
			}
		},
		handleClose1(val, tag) {
			var obj = {
				orderMarkId: tag.itemTypeId,
				purchaseMark: val.purchaseMark,
				channelMark: val.channelMark,
				id: val.id,
				orderMark: val.orderMark,
			}
			ajaxPost(
				Baseurl + 'orderController/deleteOrderPurchaseMark',
				obj
			).then((res) => {
				if (res.data.code == 200) {
					this.Search()
				} else {
					this.$message.error(res.data.data)
				}
			})
		},
		handleClose2(val, tag) {
			var obj = {
				orderMarkId: tag.itemTypeId,
				purchaseMark: val.purchaseMark,
				channelMark: val.channelMark,
				id: val.id,
				orderMark: val.orderMark,
			}
			ajaxPost(
				Baseurl + 'orderController/deleteOrderChannelMark',
				obj
			).then((res) => {
				if (res.data.code == 200) {
					this.Search()
				} else {
					this.$message.error(res.data.data)
				}
			})
		},
		//订单、订单号标签
		orderTag() {
			var obj = { itemCode: 'HYXUN0000010' }
			ajaxPost(Baseurl + 'purchaseController/selectItemList', obj).then(
				(res) => {
					if (res.data.code == 200) {
						this.colorList1 = res.data.data
						this.sortByKey(this.colorList1, 'itemTypeIdInteger')
					}
				}
			)
		},
		//国内订单标签
		domesticTag() {
			var obj = { itemCode: 'HYXUN0000011' }
			ajaxPost(Baseurl + 'purchaseController/selectItemList', obj).then(
				(res) => {
					if (res.data.code == 200) {
						this.colorList2 = res.data.data
						this.sortByKey(this.colorList2, 'itemTypeIdInteger')
					}
				}
			)
		},
		//国际订单标签
		internationalTag() {
			var obj = { itemCode: 'HYXUN0000012' }
			ajaxPost(Baseurl + 'purchaseController/selectItemList', obj).then(
				(res) => {
					if (res.data.code == 200) {
						this.colorList3 = res.data.data
						this.sortByKey(this.colorList3, 'itemTypeIdInteger')
					}
				}
			)
		},
		//订单类型标签
		ordertypeTag() {
			var obj = { itemCode: 'HYXUN0000015' }
			ajaxPost(Baseurl + 'purchaseController/selectItemList', obj).then(
				(res) => {
					if (res.data.code == 200) {
						let obj = {};
						res.data.data.forEach(item => {
							obj[item.itemTypeId] = item
						});
						this.colorList4 = obj;
					}
				}
			)
		},
		getRate() {
			ajaxPost(Baseurl + 'rateController/getRate').then((res) => {
				const { code, data } = res.data
				if (code === 200) {
					this.rate = data
				}
				// console.log(this.rate)
			})
		},
		//关闭编辑页面调用init方法
		edit(data) {
			this.Search()
		},
		init() {
			this.loadingStatus = true
			this.shopIds = this.strSeller.shopIds

			this.Search()
			ajaxPost(Baseurl + 'roleController/selectNextAndSellerInfoByRid', {
				rid: this.str.rid,
				system: this.str.system,
				companyId: this.str.company_id,
				sellerType: this.sellerType
			}).then((res) => {
				this.arr = res.data.data.next
				this.shopIds = this.strSeller.shopIds
				this.changePurchaseStatus(this.tableData)
				const { type: companyType } = this.str
				if (
					companyType === 1 &&
					this.str.superDepartmentName !== '客服部' &&
					this.str.superDepartmentName !== '常规客服部'
				) {
					this.disabledInput2 = false
					this.disabledInput3 = false
					this.disabledInput4 = false
					this.arr6 = res.data.data.next
				} else if (
					companyType === 2 ||
					(companyType === 1 &&
						this.str.superDepartmentName === '客服部') ||
					(companyType === 1 &&
						this.str.superDepartmentName === '常规客服部')
				) {
					this.disabledInput2 = false
					this.disabledInput3 = false
					this.disabledInput4 = false
					this.arr7 = res.data.data.next
					console.log(companyType)
				} else if (
					this.state === 1 ||
					(this.str.type === 3 &&
						this.str.system === 5 &&
						this.str.superDepartmentName === '财务部') ||
					(this.str.type === 3 &&
						this.str.system === 5 &&
						this.str.superDepartmentName === '人事部')
				) {
					this.disabledInput = false
					this.disabledInput2 = false
					this.disabledInput3 = false
					this.disabledInput4 = false
					this.arr1 = res.data.data.next
				} else if (this.state === 2) {
					this.disabledInput = true
					this.disabledInput2 = false
					this.disabledInput3 = false
					this.disabledInput4 = false
					this.arr1 = res.data.data.next
				} else if (this.state === 3) {
					this.disabledInput = true
					this.disabledInput2 = true
					this.disabledInput3 = false
					this.disabledInput4 = false
					this.arr2 = res.data.data.next
				} else if (this.state === 4) {
					this.disabledInput = true
					this.disabledInput2 = true
					this.disabledInput3 = true
					this.disabledInput4 = false
					this.arr3 = res.data.data.next
				} else if (this.state === 5) {
					this.disabledInput = true
					this.disabledInput2 = true
					this.disabledInput3 = true
					this.disabledInput4 = true
					var sellerInfos = res.data.data.next
					var newArr = []
					var num = 0
					for (var i = 0; i < sellerInfos.length; i++) {
						var shop = sellerInfos[i].countryMarks;
						const state = sellerInfos[i]['state'];
						const sellerId = sellerInfos[i]['id']; // 获取seller_info_id
						for (var j = 0; j < shop.length; j++) {
							shop[j]['state1'] = state;
							shop[j]['sellerInfoId'] = sellerId; // 添加seller_info_id
							newArr[num] = shop[j]
							// newArr[num] = shop[j];
							num++
						}
					}
					this.arr4 = newArr
					// 更新店铺导出列表
					this.updateExportShopList(newArr)
					// this.arr4 = newArr.sort((a, b) => a.order - b.order);
				}
			})
		},
		getCompanyInfo() {
			ajaxPost(Baseurl + 'companyController/selectCompanyByCompanyId', {
				id: this.str.company_id,
				type: this.str.type,
			}).then((res) => {
				if (res.data.code == 200) {
					this.companyInfo = res.data.data
				}
			})
		},
		getCompanyMoney() {
			const API =
				Baseurl + 'companyController/selectCompanyBalanceByCompanyId'
			const paramsData = { id: this.companyId }

			ajaxPost(API, paramsData).then((res) => {
				const { code, data } = res.data
				if (code === 200) {
					this.companyInfo = data
				}
			})
		},
		// shopChange1(value1) {
		//     this.arr2 = [];
		//     this.arr3 = [];
		//     this.arr4 = [];
		//     this.arr5 = [];
		//     this.value2 = "";
		//     this.value3 = "";
		//     this.value4 = "";
		//     this.value5 = "";
		//     console.log(value1);
		//     ajaxPost(
		//         Baseurl + "roleController/selectNextAndSellerInfoByRid",
		//         {
		//             rid: value1.rid,
		//             system: 2
		//         }
		//     ).then(res => {
		//         this.arr1 = res.data.data.next;
		//         var ids = [];
		//         var sellerInfo = res.data.data.sellerInfo;
		//         var num = 0;
		//         for(var i =0;i<sellerInfo.length;i++){
		//             var shop = sellerInfo[i].countryMarks;
		//             for(var j =0; j<shop.length;j++){
		//                 ids[num] = shop[j].shopId;
		//                 num++;
		//             }
		//         }
		//         this.shopIds = ids;
		//         console.log(this.arr1);
		//     });
		// },
		shopChange2(value2) {
			this.arr3 = []
			this.arr4 = []
			this.arr5 = []
			this.value3 = ''
			this.value4 = ''
			this.value5 = ''
			this.rid = value2.rid
			console.log(value2)
			ajaxPost(Baseurl + 'roleController/selectNextAndSellerInfoByRid', {
				rid: value2.rid,
				system: 3,
				companyId: this.companyId,
				sellerType: this.sellerType
			}).then((res) => {
				this.arr2 = res.data.data.next
				this.shopIds = res.data.data.shopIds
				console.log(this.arr2)
			})
		},
		shopChange3(value3) {
			console.log(value3)
			this.arr4 = []
			this.arr5 = []
			this.value4 = ''
			this.value5 = ''
			this.rid = value3.rid
			ajaxPost(Baseurl + 'roleController/selectNextAndSellerInfoByRid', {
				rid: value3.rid,
				system: 4,
				companyId: this.companyId,
				sellerType: this.sellerType
			}).then((res) => {
				this.arr3 = res.data.data.next
				this.shopIds = res.data.data.shopIds
				console.log(this.arr3)
			})
		},
		shopChange4(value4) {
			console.log(value4)
			this.arr5 = []
			this.value5 = ''
			this.rid = value4.rid
			ajaxPost(Baseurl + 'roleController/selectNextAndSellerInfoByRid', {
				rid: value4.rid,
				system: 5,
				companyId: this.companyId,
				sellerType: this.sellerType
			}).then((res) => {
				var sellerInfos = res.data.data.next
				var newArr = []
				var ids = []
				var num = 0
				for (var i = 0; i < sellerInfos.length; i++) {
					var shop = sellerInfos[i].countryMarks;
					const state = sellerInfos[i]['state'];
					const sellerId = sellerInfos[i]['id']; // 获取seller_info_id
					for (var j = 0; j < shop.length; j++) {
						shop[j]['state1'] = state;
						shop[j]['sellerInfoId'] = sellerId; // 添加seller_info_id
						newArr[num] = shop[j]
						ids[num] = shop[j].shopId
						num++
					}
				}
				this.arr4 = newArr
				this.shopIds = res.data.data.shopIds
				// 更新店铺导出列表
				this.updateExportShopList(newArr)
				console.log(this.arr4)
			})
		},
		shopChange8() {
			// console.log(this.arr4.length)
			// if(this.arr4.length != 0) {
			ajaxPost(Baseurl + 'roleController/selectNextAndSellerInfoByRid', {
				rid: this.rid,
				system: this.str.system,
				companyId: this.companyId,
				sellerType: this.sellerType
			}).then((res) => {
				// var sellerInfos = res.data.data.next
				// console.log(sellerInfos)
				// var newArr = []
				// var ids = []
				// var num = 0
				// for (var i = 0; i < sellerInfos.length; i++) {
				// 	var shop = sellerInfos[i].countryMarks
				// 	for (var j = 0; j < shop.length; j++) {
				// 		newArr[num] = shop[j]
				// 		ids[num] = shop[j].shopId
				// 		num++
				// 	}
				// }
				console.log(this.state)
				if (
					this.state === 1 ||
					(this.str.type === 3 &&
						this.str.system === 5 &&
						this.str.superDepartmentName === '财务部') ||
					(this.str.type === 3 &&
						this.str.system === 5 &&
						this.str.superDepartmentName === '人事部')
				) {
					this.arr1 = res.data.data.next
					this.arr2 = []
					this.arr3 = []
					this.arr4 = []
					this.arr5 = []
					this.value2 = ''
					this.value3 = ''
					this.value4 = ''
					this.value5 = ''
				} else if (this.state === 2) {
					this.arr1 = res.data.data.next
					this.arr2 = []
					this.arr3 = []
					this.arr4 = []
					this.arr5 = []
					this.value2 = ''
					this.value3 = ''
					this.value4 = ''
					this.value5 = ''
				} else if (this.state === 3) {
					this.arr2 = res.data.data.next
					this.arr3 = []
					this.arr4 = []
					this.arr5 = []
					this.value3 = ''
					this.value4 = ''
					this.value5 = ''
				} else if (this.state === 4) {
					this.arr3 = res.data.data.next
					this.arr4 = []
					this.arr5 = []
					this.value4 = ''
					this.value5 = ''
				} else if (this.state === 5) {
					var sellerInfos = res.data.data.next
					var newArr = []
					var num = 0
					for (var i = 0; i < sellerInfos.length; i++) {
						var shop = sellerInfos[i].countryMarks;
						const state = sellerInfos[i].state;
						const sellerId = sellerInfos[i].id; // 获取seller_info_id
						for (var j = 0; j < shop.length; j++) {
							shop[j]['state1'] = state;
							shop[j]['sellerInfoId'] = sellerId; // 添加seller_info_id
							newArr[num] = shop[j];
							// newArr[num] = shop[j];
							num++
						}
					}
					this.arr4 = newArr
					// 更新店铺导出列表
					this.updateExportShopList(newArr)
					this.arr5 = []
					this.value5 = ''
				}
				this.shopIds = res.data.data.shopIds
			})
			// }
		},
		shopChange5(value5) {
			// this.sellerIds = item;
			// this.rid = ''
			this.shopIds = value5.shopId ? [value5.shopId] : []
		},
		shopChange6(value6) {
			console.log(value6)
			this.arr1 = []
			this.arr2 = []
			this.arr3 = []
			this.arr4 = []
			this.arr5 = []
			this.arr7 = []
			this.value1 = ''
			this.value2 = ''
			this.value3 = ''
			this.value4 = ''
			this.value5 = ''
			this.value7 = ''
			this.companyId = value6.company_id
			this.rid = value6.rid
			ajaxPost(Baseurl + 'roleController/selectNextAndSellerInfoByRid', {
				rid: value6.rid,
				system: 1,
				companyId: this.companyId,
				sellerType: this.sellerType
			}).then((res) => {
				const { code, data } = res.data
				if (code === 200) {
					this.arr7 = data.next
					this.shopIds = data.shopIds
					this.getCompanyMoney()
				}
			})
		},
		shopChange7(value7) {
			console.log(value7)
			this.arr1 = []
			this.arr2 = []
			this.arr3 = []
			this.arr4 = []
			this.arr5 = []
			this.value1 = ''
			this.value2 = ''
			this.value3 = ''
			this.value4 = ''
			this.value5 = ''
			this.companyId = value7.company_id
			this.sellerType = '';
			this.rid = value7.rid
			ajaxPost(Baseurl + 'roleController/selectNextAndSellerInfoByRid', {
				rid: value7.rid,
				system: 1,
				companyId: this.companyId,
				sellerType: this.sellerType
			}).then((res) => {
				const { code, data } = res.data
				if (code === 200) {
					this.arr1 = data.next
					this.shopIds = data.shopIds
					this.getCompanyMoney()
				}
			})
			this.getItemList();
		},
		Search2() {
			this.currentpage = 1
			this.Search()
		},
		Search() {
			// if (Object.keys(this.value6).length && !Object.keys(this.value7).length) {
			//     this.$message.warning("请选择子公司");
			//     this.tableData = [];
			//     this.total = 0;
			//     return;
			// }
			// if (Object.keys(this.value6).length && Object.keys(this.value7).length && !this.shopIds.length) {
			//     this.$message.warning("该子公司下没有绑定店铺");
			//     this.tableData = [];
			//     this.total = 0;
			//     return;
			// }
			var begin = this.ruleForm.starttime
			if (begin == null || begin == '') {
				begin = ''
			} else {
				begin =
					new Date(this.ruleForm.starttime)
						.toLocaleDateString()
						.replace(/\//g, '-') +
					' ' +
					new Date(this.ruleForm.starttime)
						.toTimeString()
						.substr(0, 8)
			}
			var end = this.ruleForm.endtime
			if (end == null || end == '') {
				end = ''
			} else {
				end =
					new Date(this.ruleForm.endtime)
						.toLocaleDateString()
						.replace(/\//g, '-') +
					' ' +
					new Date(this.ruleForm.endtime).toTimeString().substr(0, 8)
			}
			this.loadingStatus = true
			var searchobj = {
				rid: this.rid,
				page: this.currentpage,
				size: this.size,
				shopIds: this.shopIds,
				orderStatus: this.orderStatus,
				purchaseDemandStatus: this.purchaseDemandStatus,
				purchaseStatus: this.purchaseStatus,  //采购状态
				beginDate: begin,
				// beginDate: '2023-08-01 00:00:00',
				endDate: end,
				searchStr: this.input,
				searchStrList: [],
				purchaseMark: this.purchaseMark,
				channelMark: this.channelMark,
				orderMark: this.orderMark,
				orderType: this.orderType,
				internalConveyNumber: this.ruleForm.internalConveyNumber,
				conveyNumber: this.ruleForm.conveyNumber,
				domesticShippingStatus: this.ruleForm.domesticvalue,  //国内发货状态
				domesticLogisticsStatus: this.ruleForm.domesticLogisticsStatus,  //国内物流状态
				purchaseEstimated: this.ruleForm.purchaseEstimated,
				logisticsEstimated: this.ruleForm.logisticsEstimated,
				addressStatus: this.ruleForm.addressStatus,  //地址状态
				internationalShippingStatus: this.ruleForm.channelStatus,  //国际发货状态
				internationalLogisticsStatus: this.ruleForm.internationalLogisticsStatus,  //国际物流状态
				countryMark: this.ruleForm.countryMark,
				sku: this.ruleForm.sku,
				systemSku: this.ruleForm.systemSku,
				sellerType: this.sellerType,
				source: this.sellerType
			}
			if (this.inputList) {
				this.$set(searchobj, 'searchStrList', this.inputList.split(' '))
			}
			// console.log(searchobj);
			ajaxPost(Baseurl + 'orderController/getOrderByAllNew', searchobj).then(
				(res) => {
					this.loadingStatus = false
					const { code, message } = res.data
					if (code === 200) {
						this.searchdata = res.data
						const result1 = res.data.data.list;
						result1.forEach((item) => {
							this.calcProfitPrice(item);
							const shopName = item['seller'] ? item['seller']['shop_name'] : '';
							if(shopName){
								const arr1 = shopName.split('-');
								if(this.designate_users.includes(arr1[arr1.length - 1])){
									item['isDesignate'] = true;
								}
							}
							if(item['address']){
								if (item['address']['addressLine1'] || item['address']['addressLine2'] || item['address']['addressLine3']) {
									item['addressStatus'] = '有地址';
								} else {
									item['addressStatus'] = '无地址';
								}
							}else{
								item['addressStatus'] = '无地址';
							}
							
							let operationName = [];
							item['orderItems'].forEach((item1)=>{
								operationName.push(item1.operationName) 
							})
							let channelWeight = 0;
							item['orderChannels'].forEach((channel)=>{
								channelWeight += channel.channelWeight ? parseFloat(channel.channelWeight) : 0
							})
							item['channelWeight'] = channelWeight;
							item['operationName'] = operationName.join(',')
							// const purchaseDate = item.purchaseDate;
							// if(purchaseDate &&
							// 	(item.orderStatus == '已发货' || item.orderStatus == '未发货') &&
							// 	(item.orderMarkItems && item.orderMarkItems.length > 0 && item.orderMarkItems[0]['itemTypeName'] == '正常') ){
							// 	const day = this.diffDaysCeil(purchaseDate);

							// }
							// 供应商尚未发货
							// 正常单   订单状态：已发货/未发货   下单时间和当前时间比，超过4天显示，向上取整
							if (!Array.isArray(item.orderChannels)) return
							item.orderChannels.forEach((key) => {
								this.$set(key, 'isActive', false)
								// key.isActive = false
							})
						})
						for (var i = 0; i < result1.length; i++) {
							for (var a = 0; a < this.platforms.length; a++) {
								if (result1[i].source == this.platforms[a].itemTypeId) {
									result1[i].sourceclass = this.platforms[a].itemTypeName;
								}
							}
						}
						this.tableData = result1;
						this.total = res.data.data.total
						this.changePurchaseStatus(this.tableData)
					} else if (code === 500) {
						this.$message.error(message)
					}
				}
			)
		},
		diffDaysCeil(date1) {
			const d1 = new Date(date1.replace(" ", "T")).getTime();
			const d2 = new Date().getTime();
			const diffTime = Math.abs(d2 - d1);
			return Math.ceil(diffTime / (1000 * 60 * 60 * 24));
		},

		handleSizeChange(val) {
			this.size = val
			this.Search()
		},
		handleCurrentChange(val) {
			this.currentpage = val
			this.Search()
		},
		// 亚马逊订单状态
		chanPurchase(val) {
			this.orderStatus = val
		},
		//采购需求状态
		changeDemand(val) {
			if (val == '未完成') {
				this.purchaseDemandStatus = '0'
			} else if (val == '已完成') {
				this.purchaseDemandStatus = '1'
			} else {
				this.purchaseDemandStatus = ''
			}
		},
		//采购状态
		changePurchase(val) {
			if (val == '未采购') {
				this.purchaseStatus = '未采购'
			} else if (val == '已采购') {
				this.purchaseStatus = '已采购'
			} else {
				this.purchaseStatus = ''
			}
		},
		// 国内物流
		chanDomestic(val) {
			this.domesticvalue = val
		},
		// 国内物流状态
		chanDomesticLogisticsStatus(val) {
			this.domesticLogisticsStatus = val
		},
		// 国际物流状态
		chanInternationalLogisticsStatus(val) {
			this.internationalLogisticsStatus = val
		},

		//选择开始时间
		startTime(val) {
			var d = new Date(val)
			var datetime =
				d.getFullYear() +
				'-' +
				(d.getMonth() + 1) +
				'-' +
				d.getDate() +
				' 00:00:00'
			this.ruleForm.starttime = datetime
			//console.log(val);
		},
		// 选择结束时间
		endTime(val) {
			var d = new Date(val)
			var datetime =
				d.getFullYear() +
				'-' +
				(d.getMonth() + 1) +
				'-' +
				d.getDate() +
				' 23:59:59'
			this.ruleForm.endtime = datetime
			// console.log(val);
		},
		// 重置
		searchReset() {
			this.radioTime = ''

			this.input = ''
			this.inputList = ''
			this.ruleForm.Ymxvalue = ''
			this.ruleForm.demandValue = ''
			this.ruleForm.purchaseValue = ''
			this.ruleForm.domesticvalue = ''
			this.ruleForm.domesticLogisticsStatus = ''
			this.ruleForm.internationalLogisticsStatus = ''
			this.ruleForm.purchaseEstimated = ''
			this.ruleForm.logisticsEstimated = ''
			this.ruleForm.channelStatus = ''
			this.ruleForm.channelStatus = ''
			this.ruleForm.countryMark = ''
			this.ruleForm.addressStatus = ''
			// this.ruleForm.starttime = ''
			// this.ruleForm.endtime = ''
			this.ruleForm.systemSku = ''
			this.ruleForm.sku = ''

			this.ruleForm.resource1 = ''
			this.ruleForm.resource2 = ''
			this.ruleForm.resource3 = ''
			this.ruleForm.resource4 = ''
				; (this.purchaseMark = ''),
					(this.channelMark = ''),
					(this.orderMark = '')
			this.orderType = '';
			this.currentpage = 1
			this.size = 20
			this.arr1 = []
			this.arr2 = []
			this.arr3 = []
			this.arr4 = []
			this.arr5 = []
			this.arr6 = []
			this.arr7 = []
			// this.value1 = "";
			this.value2 = ''
			this.value3 = ''
			this.value4 = ''
			this.value5 = ''
			this.value6 = ''
			this.value7 = ''
			this.sellerType = ''

			this.orderStatus = ''
			this.purchaseDemandStatus = ''

			this.ruleForm.internalConveyNumber = ''
			this.ruleForm.conveyNumber = ''

			var str = JSON.parse(localStorage.getItem('role'))
			this.companyId = str.company_id
			this.state = str.system
			this.rid = str.rid
			this.init()
		},
		// 操作
		operation(e) {
			this.$refs.editpanel.init(e) //子级的init
		},
		handleSelect(item) { },
		// 运单
		Domestic(content) {
			this.$refs.Waybill.init(content)
		},
		// 下载订单
		async handleDown() {
			// this.shopIds.map()
			// this.shopIds.map(v => {});
			// this.shopIds
			// this.loading = true;
			// console.log(this.shopIds);
			this.downloadDialog = false
			this.issloading1 = true
			let shopIds = []
			if (this.downLoadValue === 'all') {
				shopIds = this.downloadOptions
					.filter((item) => item.value !== 'all')
					.map((item) => item.value)
			} else {
				shopIds = [this.downLoadValue]
			}
			this.$message.success('正在下载中，请稍候...')
			for (let i = 0; i < shopIds.length; i++) {
				console.log(i)
				await ajaxPost(Baseurl + 'orderController/updateAmazonOrder', {
					id: shopIds[i],
				}).then((res) => {
					if (res) {
						// this.loading = false;
						this.$message.success(res.data.data)
						// this.$alert(`${res.data.data}`, "下载提示");
					}
					this.issloading1 = false
				})
			}
		},
		// handleDownload() {
		// 	ajaxPost(Baseurl + 'sellerController/getSellerByRid', {
		// 		rid: this.str.rid,
		// 	}).then((res) => {
		// 		console.log(res.data.data)
		// 		const { code, data } = res.data
		// 		if (code === 200) {
		// 			this.downloadOptions = [
		// 				{
		// 					value: 'all',
		// 					label: '所有',
		// 				},
		// 			]
		// 			data.forEach((v) => {
		// 				console.log(v.shop_name, v.id)
		// 				this.downloadOptions.push({
		// 					value: v.id,
		// 					label: v.shop_name,
		// 				})
		// 			})
		// 			this.downloadDialog = true
		// 		}
		// 	})
		// },
		// 订单导出
		async handleExport() {
			if (!this.exportTime?.length) {
				this.$message.error("请先选择导出时间！");
				return;
			}
			// 根据选择的版本调用不同的接口
			const apiUrl = this.exportVersion === '2'
				? '/orderController/exportStorePerformanceByCompangId_1'  // 优化版
				: '/orderController/exportStorePerformanceByCompangId';  // 标准版

			try {
				this.exportLoading = true;
				// 使用新页面弹出方式下载（避免 CORS 问题）
				const exportBaseUrl = this.exportVersion === '2'
					? 'https://gknb8njllssp.xiaomiqiu.com/api'
					: Baseurl;
				const url = `${exportBaseUrl}${apiUrl}?companyId=${this.companyId}&startTime=${this.exportTime[0]}&endTime=${this.exportTime[1]}`;
				window.open(url, '_blank');
				this.$message.success('导出请求已发送，请查收下载文件！');
			} catch (error) {
				console.error('导出失败：', error);
				this.$message.error('导出失败：' + (error.message || '未知错误'));
			} finally {
				// 隐藏loading状态
				this.exportLoading = false;
			}
		},
		// 店铺订单导出
		async handleShopExport() {
			if (!this.shopExportTime?.length) {
				this.$message.error("请先选择导出时间！");
				return;
			}
			if (!this.shopExportId) {
				this.$message.error("请先选择店铺！");
				return;
			}

			try {
				this.shopExportLoading = true;
				const apiUrl = '/orderController/exportStorePerformanceByCompangId_1'; // 使用优化版接口
				const exportBaseUrl = 'https://gknb8njllssp.xiaomiqiu.com/api';
				const url = `${exportBaseUrl}${apiUrl}?companyId=${this.shopExportId}&startTime=${this.shopExportTime[0]}&endTime=${this.shopExportTime[1]}`;
				window.open(url, '_blank');
				this.$message.success('导出请求已发送，请查收下载文件！');
			} catch (error) {
				console.error('导出失败：', error);
				this.$message.error('导出失败：' + (error.message || '未知错误'));
			} finally {
				this.shopExportLoading = false;
			}
		},
		// 更新店铺导出列表（聚合去重）
		updateExportShopList(shopList) {
			if (shopList && shopList.length > 0) {
				// 按 sellerInfoId 聚合，去除重复的店铺
				const shopMap = new Map();
				shopList.forEach(shop => {
					if (shop.sellerInfoId && !shopMap.has(shop.sellerInfoId)) {
						// 去掉国家后缀，提取纯店铺名称
						let shopName = shop.shopName;
						// 移括号内容 "(Amazon)(美国)" 等
						shopName = shopName.replace(/\([^)]*\)$/g, '').trim();
						shopMap.set(shop.sellerInfoId, {
							...shop,
							shopName: shopName
						});
					}
				});
				this.exportShopList = Array.from(shopMap.values());
			}
		},
		// 判断订单导出按钮是否存在
		exportShow() {
			ajaxPost(Baseurl + '/companyController/getCompanyIdsApplyOrderExport').then((res) => {
				let { company_id, system } = JSON.parse(localStorage.getItem("role"));
				// 只有管理员（system=1）且在白名单中才显示"订单导出"，否则显示"店铺订单导出"
				this.exportBool = system === 1 && res.data.data.includes(company_id);
			})
		},
		// 批量同步订单
		async syncOrders(){
			const arr = this.multipleSelection;
			if(arr.length == 0){
				this.$message({
					message: "请选择订单",
					type: "warning"
				})
				return
			}
			this.$message({
				message: "同步中，请稍后",
				type: "success"
			})
			this.loadingStatus = true;
			const obj = {};
			for(let i = 0; i < arr.length; i++){
				const amazonOrderId = arr[i]['amazonOrderId'];
				const orderNumber = arr[i]['orderNumber'];
				const sellerId = arr[i]['seller']['id'];
				if(!obj[sellerId]){
					obj[sellerId] = [];
				}
				if(arr[i]['source'] == 16){
					obj[sellerId].push(orderNumber);
				}else{
					obj[sellerId].push(amazonOrderId);
				}
			}
			
			const allPro = [];
			for(let sellerId in obj){
				const arr = obj[sellerId];
				const pro = ajaxPost(Baseurl + 'amazonOrderController/batchSyncOrders',
					{
						amazonOrderIdList: arr,
						id: sellerId,
					}
				)
				allPro.push(Promise.resolve(pro)); // 强制转为 Promise
			}
			Promise.all(allPro).then(()=>{
				this.$message({
					message: "同步成功，正在重新获取数据",
					type: "success"
				})
				this.Search2();
			})
			
		},
		// 同步订单
		handleSync(value) {
			if (value == 1) {
				this.syncIstrue = false
			} else {
				this.value6 = this.multipleSelection
					.map((x) => x.amazonOrderId)
					.join(' ')
				this.syncIstrue = true
				this.errorList = []
			}
			// alert("同步订单");
			var str = JSON.parse(localStorage.getItem('role'))
			console.log(str.rid)
			ajaxPost(Baseurl + 'sellerController/getSellerByRid', {
				rid: str.rid,
			}).then((res) => {
				console.log(res.data.data)
				this.options = []
				res.data.data.map((v) => {
					console.log(v.shop_name, v.id)
					this.options.push({
						value: v.id,
						label: v.shop_name,
					})
				})
				// this.options.
				this.dialog = true
			})
		},
		handleTrue() {
			if (this.syncIstrue == false) {
				if (this.value6 && this.value) {
					this.issloading = true
					ajaxPost(
						Baseurl + 'orderController/updateOrderByAmazonOrderId',
						{
							amazonOrderId: this.value6,
							id: this.value,
						}
					).then((res) => {
						if (res.data.code == 200) {
							// console.log(res.data);
							this.$notify.info({
								title: '消息',
								message: `${res.data.data}`,
							})
							// this.$message({
							//     message: "同步订单完成",
							//     type: "success"
							// });
							this.issloading = false
							this.dialog = false
							this.value6 = ''
							this.value = ''
							this.Search2()
						} else {
							this.issloading = false
							this.$message({
								message: res.data.data,
								type: 'error',
							})
						}
					})
				} else {
					this.$message.error('请检查信息是否完整')
				}
			} else {
				if (this.value6) {
					this.issloading = true
					ajaxPost(
						Baseurl + 'amazonOrderController/batchSyncOrders',
						{
							amazonOrderIdList: this.value6.split(' '),
							id: this.value,
						}
					).then((res) => {
						if (res.data.code == 200) {
							console.log(res.data);
							// this.$message({
							//     message: "同步订单完成",
							//     type: "success"
							// });
							if (res.data.data.errorList.length > 1) {
								this.errorList = res.data.data.errorList
								this.issloading = false
							} else {
								this.issloading = false
								this.dialog = false
								this.value6 = ''
								this.value = ''
								this.Search2()
							}

						} else {
							this.issloading = false
							this.$message({
								message: res.data.data,
								type: 'error',
							})
						}
					})
				} else {
					this.$message.error('请检查信息是否完整')
				}
			}

		},
		handleCancel() {
			this.$message('已取消')
			this.dialog = false
			this.value6 = ''
			this.value = ''
		},
		changePurchaseStatus(data) {
			if (!data || !data.length) return
			var param = data
			for (var j = 0; j < param.length; j++) {
				var purchaseDemands = param[j].purchaseDemands
				for (var i = 0; i < purchaseDemands.length; i++) {
					var purchaseItems = purchaseDemands[i].purchaseItems
					// for (var k = 0; k < purchaseItems.length; k++) {
					//     if (purchaseItems[k].purchaseStatus == 1) {
					//         param[j].purchaseDemands[i].purchaseItems[k].purchaseStatus = "代采购";
					//     } else if (purchaseItems[k].purchaseStatus == 2) {
					//         param[j].purchaseDemands[i].purchaseItems[k].purchaseStatus = "已采购";
					//     } else if (purchaseItems[k].purchaseStatus == 3) {
					//         param[j].purchaseDemands[i].purchaseItems[k].purchaseStatus = "已发货";
					//     } else if (purchaseItems[k].purchaseStatus == 4) {
					//         param[j].purchaseDemands[i].purchaseItems[k].purchaseStatus = "已签收";
					//     } else if (purchaseItems[k].purchaseStatus == 5) {
					//         param[j].purchaseDemands[i].purchaseItems[k].purchaseStatus = "退货";
					//     }
					// }
				}
			}
			this.tableData = param
		},
		calcProfitPrice(row) {
			const {
				purchaseDemands = [],
				feeAmount = 0, // 佣金
				shipping = 0, // 国际运费
				money, // 订单金额
				refund = 0, // 退款
				refundCommission = 0, // 退款管理费
				commissionFeeAmount = 0, // 退款佣金
				countryMarks: { countryMark }, // 国家标识
				// amountChina, // 中国价格
				platformFee, // 平台费用
				channelShipping, //运费
				totalAfterSalesFee, //售后
				tax, // 税,
				feeAmountChina, // 佣金对应的人民币
				inventoryFee, //库存成本
				refundChina = 0, // 退款对应的人民币
				refundCommissionChina = 0, // 退款管理费对应的人民币
				commissionFeeAmountChina,
				csbafeeChina,
				csbafee,
				taxChina,
				source,
				financialDataJson,
				accrualsForSale,
				saleCommission,
				processingAndDelivery,
				refundsAndCancellations,
				servicesAmount,
				compensationAmount,
				moneyTransfer,
				othersAmount
			} = row;
			if(source == 8){ //ozon特殊处理
				const beforePrice = (
					+accrualsForSale +
					+saleCommission + // 如果需要减掉，返回值是一个负数
					+servicesAmount +
					+processingAndDelivery + 
					+refundsAndCancellations + 
					+compensationAmount +
					+moneyTransfer + 
					+othersAmount
				).toFixed(2)
				this.$set(row, 'beforePrice', beforePrice) //到账:
				const rate1 = this.rate.find(item => item.currencyCode === "RUB");
				const afterRatePrice = ((+beforePrice || 0) * rate1['exchangeRate']).toFixed(2);
				this.$set(row, 'afterRatePrice', afterRatePrice); // 到账的人民币
				// // 采购价/成本
				let costPrice = purchaseDemands
					.reduce((total, item) => {
						return (total += item.purchaseItems.length
							? item.purchaseItems.reduce((result, key) => {
								return (result +=
									key.purchasePrice -
									// key.rebatePrice -
									key.otherPrice)
							}, 0)
							: 0)
					}, 0)
					.toFixed(2)
				this.$set(row, 'costPrice', costPrice)
				const { amount = 0, amountChina = 0 } = money || {}
				let cusAmount = amount
				this.$set(row, 'cusAmount', cusAmount)
				
				// 汇率数据
				// const reteData = this.rate.find(item => item.countryCode === countryMark);
				/**
				 * afterRatePrice 转换汇率之后 CNY
				 * 规则：中国的价格 - 佣金对应的人民币 - 退款对应的人民币 - 退款管理费对应的人民币
				 */
				// 规则：利润 = (订单金额 - 佣金 - 退款 - 退款管理费)(换成CNY) - 采购价 - 国际运费 - 平台管理费(先为0)
				let profitPrice = (
					afterRatePrice -
					costPrice -
					shipping -
					platformFee -
					channelShipping -
					inventoryFee +
					totalAfterSalesFee * 1
				).toFixed(2)
				this.$set(row, 'profitPrice', profitPrice)
				return profitPrice
			}else if(source == 16){
				const mfd = row.mercadolibreFeeDetail;
				let logisticsFee, logisticsFeeCurrency, saleFee, saleFeeCurrency, logisticsFeeCn, saleFeeCn;
				if(mfd){
					logisticsFee = mfd.logisticsFee;
					logisticsFeeCurrency = mfd.logisticsFeeCurrency;
					saleFee = mfd.saleFee;
					saleFeeCurrency = mfd.saleFeeCurrency;
					const rate1 = this.rate.find(item => item.currencyCode === logisticsFeeCurrency);
					if(rate1){
						logisticsFeeCn = ((logisticsFee ? +logisticsFee : 0) * rate1['exchangeRate']).toFixed(2);
					}

					const rate2 = this.rate.find(item => item.currencyCode === saleFeeCurrency);
					if(rate2){
						saleFeeCn = ((saleFee ? +saleFee : 0) * rate2['exchangeRate']).toFixed(2);
					}

					this.$set(row, "saleFee", saleFee);
					this.$set(row, "saleFeeCurrency", saleFeeCurrency);
					this.$set(row, "logisticsFee", logisticsFee);
					this.$set(row, "logisticsFeeCurrency", logisticsFeeCurrency);
					this.$set(row, "saleFeeCn", saleFeeCn);
					this.$set(row, "logisticsFeeCn", logisticsFeeCn);
				}
				
				// 采购价/成本
				let costPrice = purchaseDemands
					.reduce((total, item) => {
						return (total += item.purchaseItems.length
							? item.purchaseItems.reduce((result, key) => {
								return (result +=
									key.purchasePrice -
									// key.rebatePrice -
									key.otherPrice)
							}, 0)
							: 0)
					}, 0)
					.toFixed(2)
				this.$set(row, 'costPrice', costPrice)
				const { amount = 0, amountChina = 0 } = money || {}
				let cusAmount = amount
				this.$set(row, 'cusAmount', cusAmount)

				// 外币 - 佣金 - 退款 - 退款管理费
				if (money.currencyCode == 'CNY') {
					// 可能有退款的情况，佣金就是正数，最终到账的需要加上这部分
					// 正常情况佣金是负数，也就是需要减掉佣金，退款金额就是0
					// 如果是退款，佣金是正数，退款金额是负数
					const feeNum = (+feeAmountChina - +commissionFeeAmountChina).toFixed(2)
					this.$set(row, 'feeNum', feeNum)// 佣金
					const refundValue = (source === 14 ? refundChina : refund);
					// 修复：正确的计算逻辑应该是减去各项费用
					const beforePrice = (
						cusAmount -
						tax -
						(feeNum ? +feeNum : 0) -
						refundValue -
						refundCommission -
						csbafee
					).toFixed(2)
					this.$set(row, 'beforePrice', beforePrice) //到账:
				} else {
					// 佣金
					const feeNum = (+feeAmount - +commissionFeeAmount).toFixed(2)
					this.$set(row, 'feeNum', feeNum)
					const refundValue = (source === 14 ? refundChina : refund);

					// 修复：正确的计算逻辑应该是减去各项费用
					const beforePrice = (
						cusAmount -
						tax -
						(feeNum ? +feeNum : 0) -
						refundValue -
						refundCommission -
						csbafee
					).toFixed(2)

					this.$set(row, 'beforePrice', beforePrice)
				}

				// 汇率数据
				// const reteData = this.rate.find(item => item.countryCode === countryMark);
				/**
				 * afterRatePrice 转换汇率之后 CNY
				 * 规则：中国的价格 - 佣金对应的人民币 - 退款对应的人民币 - 退款管理费对应的人民币
				 */
				const feeNumChina = (+feeAmountChina - +commissionFeeAmountChina).toFixed(2)
				let afterRatePrice = (
					+amountChina -
					+taxChina -
					(feeNumChina ? +feeNumChina : 0) -
					+refundChina -
					+refundCommissionChina -
					+csbafeeChina
				).toFixed(2)
				this.$set(row, 'afterRatePrice', afterRatePrice)
				// 规则：利润 = (订单金额 - 佣金 - 退款 - 退款管理费)(换成CNY) - 采购价 - 国际运费 - 平台管理费(先为0)
				let profitPrice = (
					afterRatePrice -
					costPrice -
					shipping -
					platformFee -
					channelShipping -
					inventoryFee +
					totalAfterSalesFee * 1
					- (+logisticsFeeCn || 0) - (+saleFeeCn || 0)
				).toFixed(2)
				profitPrice = (+profitPrice).toFixed(2);
				// console.log(profitPrice)
				this.$set(row, 'profitPrice', profitPrice)
				return profitPrice
			}else{
				let financialNum = 0; // 佣金数据，如果有值返回是负数
				const rate1 = this.rate.find(item => item.currencyCode === "RUB");
				const processingAndDelivery1 = (+processingAndDelivery || 0) * rate1['exchangeRate'];
				const servicesAmount1 = (+servicesAmount || 0) * rate1['exchangeRate'];
				this.$set(row, "processingAndDelivery", +processingAndDelivery1.toFixed(2));
				this.$set(row, "servicesAmount", +servicesAmount1.toFixed(2));
				financialNum += (+processingAndDelivery1 || 0);
				financialNum += (+servicesAmount1 || 0);
				// 采购价/成本
				let costPrice = purchaseDemands
					.reduce((total, item) => {
						return (total += item.purchaseItems.length
							? item.purchaseItems.reduce((result, key) => {
								return (result +=
									key.purchasePrice -
									// key.rebatePrice -
									key.otherPrice)
							}, 0)
							: 0)
					}, 0)
					.toFixed(2)
				this.$set(row, 'costPrice', costPrice)
				const { amount = 0, amountChina = 0 } = money || {}
				let cusAmount = amount
				this.$set(row, 'cusAmount', cusAmount)
				
				// 外币 - 佣金 - 退款 - 退款管理费
				if(money.currencyCode == 'CNY'){
					// 可能有退款的情况，佣金就是正数，最终到账的需要加上这部分
					// 正常情况佣金是负数，也就是需要减掉佣金，退款金额就是0
					// 如果是退款，佣金是正数，退款金额是负数
					const feeNum = (+feeAmountChina - +commissionFeeAmountChina).toFixed(2)
					this.$set(row, 'feeNum', feeNum)// 佣金
					const refundValue = (source === 14 ? refundChina : refund);
					// 修复：正确的计算逻辑应该是减去各项费用
					const beforePrice = (
						cusAmount -
						tax -
						(feeNum ? +feeNum : 0) -
						refundValue -
						refundCommission -
						csbafee
					).toFixed(2)
					this.$set(row, 'beforePrice', beforePrice) //到账:
				}else{
					// 佣金
					const feeNum = (+feeAmount - +commissionFeeAmount).toFixed(2)
					this.$set(row, 'feeNum', feeNum)
					const refundValue = (source === 14 ? refundChina : refund);

					// 修复：正确的计算逻辑应该是减去各项费用
					const beforePrice = (
						cusAmount -
						tax -
						(feeNum ? +feeNum : 0) -
						refundValue -
						refundCommission -
						csbafee
					).toFixed(2)

					this.$set(row, 'beforePrice', beforePrice)
				}
				
				// 汇率数据
				// const reteData = this.rate.find(item => item.countryCode === countryMark);
				/**
				 * afterRatePrice 转换汇率之后 CNY
				 * 规则：中国的价格 - 佣金对应的人民币 - 退款对应的人民币 - 退款管理费对应的人民币
				 */
				const feeNumChina = (+feeAmountChina - +commissionFeeAmountChina).toFixed(2)
				let afterRatePrice = (
					+amountChina -
					+taxChina -
					(feeNumChina ? +feeNumChina : 0) -
					+refundChina -
					+refundCommissionChina -
					+csbafeeChina
				).toFixed(2)
				this.$set(row, 'afterRatePrice', afterRatePrice)
				// 规则：利润 = (订单金额 - 佣金 - 退款 - 退款管理费)(换成CNY) - 采购价 - 国际运费 - 平台管理费(先为0)
				let profitPrice = (
					afterRatePrice -
					costPrice -
					shipping -
					platformFee -
					channelShipping -
					inventoryFee +
					totalAfterSalesFee * 1
				).toFixed(2)
				profitPrice = (+profitPrice + +financialNum).toFixed(2);
				// console.log(profitPrice)
				this.$set(row, 'profitPrice', profitPrice)
				return profitPrice
			}
			
		},
		handleSizeWaybillChange(val) {
			this.waybillSize = val
			this.loadingTable = true;
			this.uploadWaybillList()
		},
		handleCurrentWaybillChange(val) {
			this.waybillPage = val
			this.loadingTable = true;
			this.uploadWaybillList()
		},
		uploadWaybillShopChange(event) {
			this.listChannel = ListChannel[event.countryName]
			this.loadingTable = true;
			this.uploadWaybillList()
		},
		//上传运单中选择平台选择之后所需要执行的函数
		uploadShopclass(event) {
			this.handleUpload(event);
		},
		handleSelectionWaybillChange(val) {
			// console.log(val);
			checkedList = val
		},
		handleRadioChange(val) {
			this.waybillType = val
			this.waybillPage = 1
			this.waybillSize = 20
			if (!Object.keys(this.uploadWaybillShop).length) {
				this.listTableWaybill = []
				return
			}
			this.loadingTable = true;
			this.uploadWaybillList()
		},
		async uploadWaybillList() {
			const API =
				Baseurl + 'orderController/getOrderChannelByCountrySellerId'
			// const countrySellerIds = this.uploadWaybillShop.countryMarks.map(item => item.shopId);
			// if (!countrySellerIds.length) return;
			const paramsData = {
				page: this.waybillPage,
				size: this.waybillSize,
				countrySellerIds: [this.uploadWaybillShop.shopId],
				numberStatus: this.waybillType,
			}
			const {
				data: { code, data },
			} = await ajaxPost(API, paramsData)
			if (code === 200) {
				if (this.waybillType === '2') {
					data.list.forEach((item) => {
						item.channelName = ''
					})
				}
				// 补充purchaseDate和latestShipDate字段
				data.list.forEach((item) => {
					// 如果purchaseDate为null，则使用createTime
					if (!item.purchaseDate && item.createTime) {
						// 只保留日期部分（YYYY-MM-DD）
						item.purchaseDate = item.createTime.split(' ')[0]
					}
					// 从主表格数据中获取latestShipDate
					const mainOrder = this.tableData.find(order => order.amazonOrderId === item.amazonOrderId)
					if (mainOrder && mainOrder.latestShipDate) {
						item.latestShipDate = mainOrder.latestShipDate
					}
				})
				this.listTableWaybill = data.list
				this.logisticsList(this.listTableWaybill)
				this.loadingTable = false;
				this.waybillTotal = data.total
				this.uploadWaybillDialog = true
			}
		},

		async updateWaybill(type) {
			if (!Object.keys(this.uploadWaybillShop).length) {
				this.$message.warning('请先选择店铺')
				return
			}
			if (!checkedList.length) {
				this.$message.warning('请先选中要上传的产品')
				return
			}
			if (type === 2) {
				const resultData = checkedList.find((item) => !item.channelName)
				if (resultData) {
					this.$message.warning('请检查所选产品的信息是否填写完整！')
					return
				}
			}
			const sayWeeeCarrierMap = {
				'UPS': 1,
				'Fedex': 2,
				'USPS': 3,
				'捷岸': 3,
				'欧邮通': 3,
				'GLS': 6,
				'DHL': 8,
				'Yun Express': 18,
				'云途': 18,
				'云途(服装)': 18,
				'云途A': 18,
				'燕文': 20,
				'Yanwen': 20,
				'递四方': 22,
				'递四方A': 22,
				'递四方速递': 22,
				'菜鸟': 40,
				'菜鸟-海度': 40,
			}
			if (this.sellerTypeID === 17) {
				for (const item of checkedList) {
					if (!sayWeeeCarrierMap[item.channelName]) {
						this.$message.error(
							`渠道"${item.channelName}"暂不支持SayWeee平台运单上传，请重新选择`
						)
						return
					}
				}
			}
			const API = Baseurl + 'amaoznFeedUpload/orderFulfillmentFeed'
			const checkedData = checkedList.map((item) => {
				if (this.sellerTypeID === 17) {
					const obj = {
						amazonOrderID: item.amazonOrderId,
						carrierName: item.channelName,
						shippingMethod: item.channelWayEn || '',
						channelName: item.channelName,
						channelType: item.type,
						orderShippingCarrierId: sayWeeeCarrierMap[item.channelName]
					}
					obj.shipperTrackingNumber =
						type === 1
							? item.conveyNumber || ''
							: item.transferOrderNumber || ''
					return obj
				}

				// console.log(JSON.parse(JSON.stringify(item)))
				if (item.channelName === '三态') {
					item.channelName1 = 'SFC'
				} else if (item.channelName === '燕文') {
					item.channelName1 = 'Yanwen'
				} else if (
					item.channelName === '云途' ||
					item.channelName === '云途(服装)' ||
					item.channelName === '云途A'
				) {
					item.channelName1 = 'Yun Express'
				} else if (
					item.channelName === '递四方' ||
					item.channelName === '递四方A'
				) {
					item.channelName1 = '4PX'
					// if (
					// 	item.countryName == '澳大利亚' ||
					// 	item.countryName == '美国' ||
					// 	item.countryName == '新加坡' ||
					// 	item.countryName == '墨西哥'
					// ) {
					// 	item.channelName1 = '4PX'
					// } else {
					// 	item.channelName1 = '递四方速递'
					// }
				} else if (item.channelName === '捷岸') {
					item.channelName1 = 'USPS'
				} else if (item.channelName === '欧邮通') {
					item.channelName1 = 'USPS'
				} else {
					item.channelName1 = item.channelName
				}
				let R = /[\u4E00-\u9FA5]/i
				if (R.test(item.channelWayEn)) {
					this.$message.error('请检查输入的运输方式，禁止输入汉字！')
					return
				}
				const obj = {
					amazonOrderID: item.amazonOrderId,
					carrierName: item.channelName1,
					shippingMethod: item.channelWayEn || '',
					channelName: item.channelName,
					channelType: item.type
				}
				// type 等于 1 上传运单号；等于 2 上传转单号；
				obj.shipperTrackingNumber =
					type === 1
						? item.conveyNumber || ''
						: item.transferOrderNumber || ''
				return obj
			})

			// return
			const paramsData = {
				marketInfo: JSON.stringify({
					sellerId: this.uploadWaybillShop.sellerId,
					mwsAuthToken: this.uploadWaybillShop.mwsAuthToken,
					marketplaceId: this.uploadWaybillShop.marketPlaceId,

				}),
				data: checkedData,
				rid: this.str.rid,
				type,
				plateType: this.sellerTypeID,
				companyId: this.str.company_id
			}
			const {
				data: { code, data },
			} = await ajaxPost(API, paramsData)
			if (code === 200) {
				this.$message.success(data)
				this.loadingTable = true;
				this.uploadWaybillList()
			} else {
				this.$message.error(data)
			}
		},
		handleUpload(sellerType) {
			var str = JSON.parse(localStorage.getItem('role'))
			// console.log(str.rid);
			ajaxPost(Baseurl + 'sellerController/selectSellerByRid', {
				rid: str.rid,
				sellerType: sellerType
			}).then((res) => {
				const { code, data } = res.data
				if (code === 200) {
					this.optionsUpload = data.reduce(
						(initArr, key) => [
							...initArr,
							...key.countryMarks.map((item) => ({
								sellerId: key.sellerId,
								mwsAuthToken: key.mwsAuthToken,
								...item,
							})),
						],
						[]
					)
					for (var i = 0; i < this.optionsUpload.length; i++) {
						if (this.optionsUpload[i].countryName === "" || this.optionsUpload[i].countryName === null) {
							this.optionsUpload[i].optionlable = this.optionsUpload[i].shopName + '';
						} else {
							this.optionsUpload[i].optionlable = this.optionsUpload[i].shopName + "(" + this.optionsUpload[i].countryName + ")";
						}
					}
					this.uploadWaybillShop = this.optionsUpload[0];
					this.uploadWaybillShopChange(this.uploadWaybillShop)
					// this.uploadWaybillDialog = true
					console.log(this.optionsUpload);
					this.loadingTable = true;
					if (this.optionsUpload.length === 0) {
						this.listTableWaybill = [];
						this.logisticsList(this.listTableWaybill);
						this.waybillTotal = 0;
						this.loadingTable = false;
						// this.uploadWaybillDialog = true;
					} else {
						const API =
							Baseurl + 'orderController/getOrderChannelByCountrySellerId'
						// const countrySellerIds = this.uploadWaybillShop.countryMarks.map(item => item.shopId);
						// if (!countrySellerIds.length) return;
						const paramsData = {
							page: this.waybillPage,
							size: this.waybillSize,
							countrySellerIds: [this.uploadWaybillShop.shopId],
							numberStatus: this.waybillType,
						}
						ajaxPost(API, paramsData).then((res) => {
							if (res.data.code === 200) {
								if (this.waybillType === '2') {
									res.data.data.list.forEach((item) => {
										item.channelName = ''
									})
								}
								// 补充purchaseDate和latestShipDate字段
								res.data.data.list.forEach((item) => {
									// 如果purchaseDate为null，则使用createTime
									if (!item.purchaseDate && item.createTime) {
										// 只保留日期部分（YYYY-MM-DD）
										item.purchaseDate = item.createTime.split(' ')[0]
									}
									// 从主表格数据中获取latestShipDate
									const mainOrder = this.tableData.find(order => order.amazonOrderId === item.amazonOrderId)
									if (mainOrder && mainOrder.latestShipDate) {
										item.latestShipDate = mainOrder.latestShipDate
									}
								})
								this.listTableWaybill = res.data.data.list
								this.loadingTable = false;
								this.logisticsList(this.listTableWaybill)
								this.waybillTotal = res.data.data.total
								// this.uploadWaybillDialog = true
							}
						})
					}
				} else {
					this.$message.error(data)
				}
			})
		},
		getOriginalImg(item) {
			// console.log(item)
			const API = Baseurl + 'productController/selectImagesByChildSku'
			const paramsData = {
				childSku: item.sellerSKU,
			}
			ajaxPost(API, paramsData).then((res) => {
				const { code, data, message } = res.data
				if (code === 200) {
					this.originalImg = data
					this.originalVisible = true
				} else {
					this.$message.error(message)
				}
			})
		},
		sortByKey(array, key) {
			return array.sort(function (a, b) {
				var x = a[key]
				var y = b[key]
				return x < y ? -1 : x > y ? 1 : 0
			})
		},
		queryExternalcall(item) {
			console.log(222)
			this.tableData.forEach((item) => {
				if (!Array.isArray(item.orderChannels)) return
				item.orderChannels.forEach((key) => {
					this.$set(key, 'isActive', false)
					// key.isActive = false
				})
			})
			item.isActive = true
			window.YQV5.trackSingleF1({
				//必须，指定悬浮位置的元素ID。
				YQ_ElementId: item.conveyNumber,
				//可选，指定查询结果宽度，最小为260px，默认为470px。
				YQ_Width: 500,
				//可选，指定查询结果高度，最大为800px，默认为560px。
				YQ_Height: 600,
				//可选，指定运输商，默认为自动识别。
				YQ_Fc: '0',
				//可选，指定UI语言，默认根据浏览器自动识别。
				YQ_Lang: 'zh-CN',
				//必须，指定要查询的单号。
				// YQ_Num: "YT2018021266048349",
				YQ_Num: item.conveyNumber,
			})
		},
		queryDomesticOrderMove(num, type) {
			const API = Baseurl + 'conveyNumberQueryController/queryTrack'
			const paramsDate = { num, type, companyId: this.str.company_id }
			return new Promise((resolve, reject) => {
				ajaxPost(API, paramsDate).then((res) => {
					const { code, data } = res.data
					if (code === 200) {
						resolve(data)
					} else {
						reject(data)
					}
				})
			})
		},
		queryDomesticOrderMoveBD(conveyNumber) {
			const API = Baseurl + 'baidianTypeController/selectTrack'
			const paramsDate = { conveyNumber }
			return new Promise((resolve, reject) => {
				ajaxPost(API, paramsDate).then((res) => {
					const { code, data } = res.data
					if (code === 200) {
						resolve(data)
					} else {
						reject(data)
					}
				})
			})
		},
		queryDomesticOrderMoveBDZY(conveyNumber) {
			const API = Baseurl + 'baidian_order/getOrderTrajectory'
			const paramsDate = { conveyNumber }
			return new Promise((resolve, reject) => {
				ajaxPost(API, paramsDate).then((res) => {
					const { code, data } = res.data
					if (code === 200) {
						resolve(data)
					} else {
						reject(data)
					}
				})
			})
		},
		queryDomesticOrderMoveWLD(conveyNumber) {
			const API = Baseurl + 'wanLeaderTypeController/getCargoTrack'
			const paramsDate = { conveyNumber }
			return new Promise((resolve, reject) => {
				ajaxPost(API, paramsDate).then((res) => {
					const { code, data } = res.data
					if (code === 200) {
						resolve(data)
					} else {
						reject(data)
					}
				})
			})
		},
		queryDomesticOrderMoveHYD(conveyNumber) {
			const API = Baseurl + 'hydTypeController/getHydTypeTrack'
			const paramsDate = { conveyNumber }
			return new Promise((resolve, reject) => {
				ajaxPost(API, paramsDate).then((res) => {
					const { code, data } = res.data
					if (code === 200) {
						resolve(data)
					} else {
						reject(data)
					}
				})
			})
		},
		queryDomesticOrderMoveAiparcel(conveyNumber) {
			const API = Baseurl + 'aiparcelTypeController/getAiparcelTrack'
			const paramsDate = { conveyNumber }
			return new Promise((resolve, reject) => {
				ajaxPost(API, paramsDate).then((res) => {
					const { code, data } = res.data
					if (code === 200) {
						resolve(data)
					} else {
						reject(data)
					}
				})
			})
		},
		queryDomesticOrderMoveJT(conveyNumber) {
			const API = Baseurl + 'jiTuTypeController/getTrackInfo'
			const paramsDate = { conveyNumber }
			return new Promise((resolve, reject) => {
				ajaxPost(API, paramsDate).then((res) => {
					const { code, data } = res.data
					if (code === 200) {
						resolve(data)
					} else {
						reject(data)
					}
				})
			})
		},
		queryDomesticOrderMoveYW(conveyNumber) {
			const API = Baseurl + 'yanWenController/getLogisticsTrack'
			const paramsDate = { conveyNumber }
			return new Promise((resolve, reject) => {
				ajaxPost(API, paramsDate).then((res) => {
					const { code, data } = res.data
					if (code === 200) {
						resolve(data)
					} else {
						reject(data)
					}
				})
			})
		},
		queryDomesticOrderMoveYunExpress(companyId, orderNumber, channelType) {
			const API = Baseurl + 'yunTuController/getTrackAllInfo'
			const paramsDate = { companyId, orderNumber, channelType }
			return new Promise((resolve, reject) => {
				ajaxPost(API, paramsDate).then((res) => {
					const { code, data } = res.data
					if (code === 200 && data.code == "0000") {
						// console.log(data);
						resolve(data)
					} else {
						reject(data)
					}
				})
			})
		},
		queryDomesticOrderMoveJA(conveyNumber) {
			const API = Baseurl + 'jieAnController/getJieAnTrack'
			const paramsDate = { conveyNumber }
			return new Promise((resolve, reject) => {
				ajaxPost(API, paramsDate).then((res) => {
					const { code, data } = res.data
					if (code === 200) {
						resolve(data)
					} else {
						reject(data)
					}
				})
			})
		},
		queryDomesticOrderMoveOuyoutong(conveyNumber) {
			const API = Baseurl + 'ouyoutongController/getOuyoutongTrack'
			const paramsDate = { conveyNumber }
			return new Promise((resolve, reject) => {
				ajaxPost(API, paramsDate).then((res) => {
					const { code, data } = res.data
					if (code === 200) {
						resolve(data)
					} else {
						reject(data)
					}
				})
			})
		},
		queryDomesticOrderMoveDealfy(conveyNumber) {
			const API = Baseurl + 'dealfyController/getTrack'
			const paramsDate = { conveyNumber }
			return new Promise((resolve, reject) => {
				ajaxPost(API, paramsDate).then((res) => {
					const { code, data } = res.data
					if (code === 200) {
						resolve(data)
					} else {
						reject(data)
					}
				})
			})
		},
		queryDomesticOrderMoveShangYi(conveyNumber) {
			const API = Baseurl + 'shangYiTypeController/queryTrack'
			const paramsDate = { conveyNumber }
			return new Promise((resolve, reject) => {
				ajaxPost(API, paramsDate).then((res) => {
					const { code, data } = res.data
					if (code === 200) {
						resolve(data)
					} else {
						reject(data)
					}
				})
			})
		},
		async popoverShow(type, item) {
			this.popoverText = '查询中...'
			this.popoverStatus = true
			try {
				if (item.createTime) {
					let str1 = new Date(item.createTime).getTime()
					let str2 = new Date('2023-08-16 00:00:00').getTime()
					if (item.type == 3 && str1 >= str2) {
						const data = await this.queryDomesticOrderMoveYW(item.conveyNumber)
						if (data) {
							if (data.result[0].checkpoints) {
								this.popoverStatus = false
								let obj = {
									nu: item.conveyNumber,
									state: 100,
									data: []
								}
								data.result[0].checkpoints.map(ele => {
									obj.data.push({
										context: ele.message,
										time: ele.time_stamp
									})
								})
								this.popoverInfo = obj
							} else {
								this.popoverStatus = true
								this.popoverText = "查询无结果，请隔段时间再查"
							}
						} else {
							this.popoverText = data.message || '查询失败'
						}
						return
					}
				}
				if (item.type == 2) {
					const data = await this.queryDomesticOrderMoveYunExpress(item.companyId, item.conveyNumber, item.type)
					if (data) {
						this.popoverStatus = false
						let obj = {
							nu: item.conveyNumber,
							state: 100,
							data: []
						}
						if (data.item.orderTrackingDetails.length > 1) {
							// 如果有多个元素，执行排序
							data.item.orderTrackingDetails.sort(function (a, b) {
								// 将日期字符串转换为 Date 对象以进行比较
								var dateA = new Date(a.processDate);
								var dateB = new Date(b.processDate);

								// 倒序排列
								if (dateA > dateB) {
									return -1;
								} else if (dateA < dateB) {
									return 1;
								} else {
									return 0;
								}
							});
						}
						data.item.orderTrackingDetails.map(ele => {
							obj.data.push({
								context: ele.processContent,
								time: ele.processDate,
								areaName: ele.processLocation
							})
						})
						this.popoverInfo = obj
						console.log(this.popoverInfo);
					} else {
						this.popoverText = data.message || '查询失败'
					}
					return
				}
				if (item.type == 12) {
					const data = await this.queryDomesticOrderMoveJA(item.conveyNumber)
					if (data) {
						this.popoverStatus = false
						let obj = {
							nu: item.conveyNumber,
							state: 100,
							data: []
						}
						data.trackDetails.map(ele => {
							obj.data.push({
								context: ele.track_content,
								time: ele.track_date
							})
						})
						this.popoverInfo = obj
					} else {
						this.popoverText = data.message || '查询失败'
					}
					return
				}
				if (item.type == 17) {
					const data = await this.queryDomesticOrderMoveBD(item.conveyNumber)
					if (data) {
						this.popoverStatus = false
						let obj = {
							nu: item.conveyNumber,
							state: 100,
							data: []
						}
						data.trackDetails.map(ele => {
							obj.data.push({
								context: ele.track_content,
								time: ele.track_date
							})
						})
						this.popoverInfo = obj
					} else {
						this.popoverText = data.message || '查询失败'
					}
					return
				}
				if (item.type == 18) {
					const data = await this.queryDomesticOrderMoveBDZY(item.conveyNumber)
					if (data.success === 1) {
						this.popoverStatus = false
						let obj = {
							nu: item.conveyNumber,
							state: 100,
							data: []
						}
						data.data.map(ele => {
							obj.data.push({
								context: ele.details[0].track_description,
								time: ele.details[0].track_occur_date
							})
						})
						this.popoverInfo = obj
					} else {
						this.popoverText = data.message || '查询失败'
					}
					return
				}
				if (item.type == 19) {
					const data = await this.queryDomesticOrderMoveWLD(item.conveyNumber)
					// const data = await this.queryDomesticOrderMoveWLD("WLDAZ2080400011")
					if (data) {
						this.popoverStatus = false
						let obj = {
							nu: item.conveyNumber,
							state: 100,
							data: []
						}
						data[0].Detail.map(ele => {
							obj.data.push({
								context: ele.Comment,
								time: ele.Occur_date
							})
						})
						this.popoverInfo = obj
					} else {
						this.popoverText = data.message || '查询失败'
					}
					return
				}
				if (item.type == 20 || item.type == 24) {
					const data = await this.queryDomesticOrderMoveHYD(item.conveyNumber)
					// const data = await this.queryDomesticOrderMoveWLD("WLDAZ2080400011")
					if (data) {
						this.popoverStatus = false
						let obj = {
							nu: item.conveyNumber,
							state: 100,
							data: []
						}
						data.trackDetails.map(ele => {
							obj.data.push({
								context: ele.track_content,
								time: ele.track_date
							})
						})
						this.popoverInfo = obj
					} else {
						this.popoverText = data.message || '查询失败'
					}
					return
				}
				if (item.type == 22) {
					const data = await this.queryDomesticOrderMoveJT(item.conveyNumber)
					// const data = await this.queryDomesticOrderMoveWLD("WLDAZ2080400011")
					if (data) {
						this.popoverStatus = false
						let obj = {
							nu: item.conveyNumber,
							state: 100,
							data: []
						}
						data[0].details.map(ele => {
							obj.data.push({
								context: ele.desc,
								time: ele.scantime
							})
						})
						this.popoverInfo = obj
					} else {
						this.popoverText = data.message || '查询失败'
					}
					return
				}
				if (item.type == 25 || item.type == 26) {
					const data = await this.queryDomesticOrderMoveAiparcel(item.conveyNumber)
					// const data = await this.queryDomesticOrderMoveWLD("WLDAZ2080400011")
					if (data) {
						this.popoverStatus = false
						let obj = {
							nu: item.conveyNumber,
							state: 100,
							data: []
						}
						data.trackDetails.map(ele => {
							obj.data.push({
								context: ele.track_content,
								time: ele.track_date
							})
						})
						this.popoverInfo = obj
					} else {
						this.popoverText = data.message || '查询失败'
					}
					return
				}
				if (item.type == 27) {
					const data = await this.queryDomesticOrderMoveDealfy(item.conveyNumber)
					if (data) {
						this.popoverStatus = false
						let obj = {
							nu: item.conveyNumber,
							state: 100,
							data: []
						}
						data.trackingList.map(ele => {
							obj.data.push({
								context: ele.description,
								time: ele.time
							})
						})
						this.popoverInfo = obj
						console.log(obj);
						console.log(this.popoverInfo)
					} else {
						this.popoverText = data.message || '查询失败'
					}
					return
				}
				if (item.type == 30) {
					const data = await this.queryDomesticOrderMoveOuyoutong(item.conveyNumber)
					if (data) {
						this.popoverStatus = false
						let obj = {
							nu: item.conveyNumber,
							state: 100,
							data: []
						}
						data.trackDetails.map(ele => {
							obj.data.push({
								context: ele.track_content,
								time: ele.track_date
							})
						})
						this.popoverInfo = obj
					} else {
						this.popoverText = data.message || '查询失败'
					}
					return
				}
				if (item.type == 34) {
					const data = await this.queryDomesticOrderMoveShangYi(item.conveyNumber)
					if (data) {
						this.popoverStatus = false
						let obj = {
							nu: item.conveyNumber,
							state: 100,
							data: []
						}
						data.map(ele => {
							obj.data.push({
								context: ele.podNameCh,
								time: ele.datetime
							})
						})
						this.popoverInfo = obj
					} else {
						this.popoverText = data.message || '查询失败'
					}
					return
				}
				let num, channel
				if (type === 'international') {
					num = item.conveyNumber
					channel = item.type
				} else {
					num = item.internalConveyNumber
					channel = null
				}
				const data = await this.queryDomesticOrderMove(num, channel)
				if (data.status === '200') {
					this.popoverStatus = false
					this.popoverInfo = data
				} else {
					this.popoverText = data.message || '查询失败'
				}
			} catch (error) {
				this.popoverText = error || '查询失败'
			}
		},
		async popoverShowTrack17(type, item) {
			this.popoverText = '查询中...'
			this.popoverStatus = true
			// console.log(type);
			// console.log(item);
			try {
				if (item.type == 12) {
					const data = await this.queryDomesticOrderMoveJA(item.conveyNumber)
					if (data) {
						this.popoverStatus = false
						let obj = {
							number: item.conveyNumber,
							state: 100,
							data: []
						}
						data.trackDetails.map(ele => {
							obj.data.push({
								context: ele.track_content,
								time: ele.track_date
							})
						})
						this.popoverInfo = obj
					} else {
						this.popoverText = data.message || '查询失败'
					}
					return
				}
				if (item.type == 17) {
					const data = await this.queryDomesticOrderMoveBD(item.conveyNumber)
					if (data) {
						this.popoverStatus = false
						let obj = {
							number: item.conveyNumber,
							state: 100,
							data: []
						}
						data.trackDetails.map(ele => {
							obj.data.push({
								context: ele.track_content,
								time: ele.track_date
							})
						})
						this.popoverInfo = obj
					} else {
						this.popoverText = data.message || '查询失败'
					}
					return
				}
				if (item.type == 20 || item.type == 24) {
					const data = await this.queryDomesticOrderMoveHYD(item.conveyNumber)
					// const data = await this.queryDomesticOrderMoveWLD("WLDAZ2080400011")
					if (data) {
						this.popoverStatus = false
						let obj = {
							number: item.conveyNumber,
							state: 100,
							data: []
						}
						data.trackDetails.map(ele => {
							obj.data.push({
								context: ele.track_content,
								time: ele.track_date
							})
						})
						this.popoverInfo = obj
					} else {
						this.popoverText = data.message || '查询失败'
					}
					return
				}
				if (item.type == 25 || item.type == 26) {
					const data = await this.queryDomesticOrderMoveAiparcel(item.conveyNumber)
					// const data = await this.queryDomesticOrderMoveWLD("WLDAZ2080400011")
					if (data) {
						this.popoverStatus = false
						let obj = {
							number: item.conveyNumber,
							state: 100,
							data: []
						}
						data.trackDetails.map(ele => {
							obj.data.push({
								context: ele.track_content,
								time: ele.track_date
							})
						})
						this.popoverInfo = obj
					} else {
						this.popoverText = data.message || '查询失败'
					}
					return
				}
				if (item.type == 30) {
					const data = await this.queryDomesticOrderMoveOuyoutong(item.conveyNumber)
					if (data) {
						this.popoverStatus = false
						let obj = {
							number: item.conveyNumber,
							state: 100,
							data: []
						}
						data.trackDetails.map(ele => {
							obj.data.push({
								context: ele.track_content,
								time: ele.track_date
							})
						})
						this.popoverInfo = obj
					} else {
						this.popoverText = data.message || '查询失败'
					}
					return
				}
				if (item.type == 34) {
					const data = await this.queryDomesticOrderMoveShangYi(item.conveyNumber)
					if (data) {
						this.popoverStatus = false
						let obj = {
							number: item.conveyNumber,
							state: 100,
							data: []
						}
						data.map(ele => {
							obj.data.push({
								context: ele.podNameCh,
								time: ele.datetime
							})
						})
						this.popoverInfo = obj
					} else {
						this.popoverText = data.message || '查询失败'
					}
					return
				}
				const API = Baseurl + 'track17Controller/gettrackinfo'
				const paramsData = [{
					number: item.conveyNumber || item.internalConveyNumber,
					carrier: !isNaN(item.companyCode) ? item.companyCode : null,
				}]
				ajaxPost(API, paramsData).then(res => {
					const { code, data } = res.data;
					if (code === 200 && data.code === 0 && data.data.accepted && data.data.accepted.length > 0) {
						this.popoverStatus = false
						this.popoverInfo = data.data.accepted[0]
					} else if (code === 200 && data.code === 0 && data.data.rejected && data.data.rejected.length > 0) {
						this.popoverText = data.data.rejected[0].error.message
					} else {
						this.popoverText = data.message || '查询失败'
					}
				});
			} catch (error) {
				this.popoverText = error || '查询失败'
			}
		},
		queryDomesticOrderClick(item) {
			const inputEle = document.createElement('input')
			inputEle.readOnly = 'readOnly'
			inputEle.style.position = 'absolute'
			inputEle.style.top = document.body.scrollTop
			inputEle.style.zIndex = '-1000'
			const appEle = document.getElementById('app')
			appEle.appendChild(inputEle)
			inputEle.setAttribute('value', item.internalConveyNumber)
			inputEle.select()
			if (document.execCommand('copy')) {
				this.$confirm('复制成功，点击确定跳转快递100页面', '提示').then(
					() => {
						window.open('https://www.kuaidi100.com/')
					}
				)
			}
			appEle.removeChild(inputEle)
		},
		submitSet() {
			if (this.purchaseCostEstimate == undefined || this.purchaseCostEstimate == null) {
				this.$message.error("采购预估费用不能为空！")
				return
			}
			if (this.logisticsCostEstimate == undefined || this.logisticsCostEstimate == null) {
				this.$message.error("物流预估费用不能为空！")
				return
			}
			let API = Baseurl + 'orderCostEstimateController/batchSetOrderCostEstimate'
			let data = {
				amazonOrderIdList: this.multipleSelection.map(x => x.amazonOrderId),
				purchaseCostEstimate: this.purchaseCostEstimate,
				logisticsCostEstimate: this.logisticsCostEstimate,
				purchaseEstimated: 1,
				logisticsEstimated: 1
			}
			this.btnSetLoading = true
			ajaxPost(API, data).then(() => {
				this.$message.success('设置成功')
				this.dialogSetFormVisible = false
				this.btnSetLoading = false
				this.Search()
			})
		},
		/**
		 * radio取消选中
		 */
		cancelSelect(e, label) {
			e === this.ruleForm[label] ? this.ruleForm[label] = '' : this.ruleForm[label] = e
			if (label == 'resource1') {
				this.radiochange1(this.ruleForm[label])
			}
			if (label == 'resource4') {
				this.radiochange4(this.ruleForm[label])
			}
			if (label == 'resource3') {
				this.radiochange3(this.ruleForm[label])
			}
			if (label == 'resource2') {
				this.radiochange2(this.ruleForm[label])
			}
		},
		cancelSelect1(e) {
			e === this.radioTime ? this.radioTime = '' : this.radioTime = e
			if (this.radioTime) {
				this.radioChangeTime(this.radioTime)
			} else {
				this.ruleForm.starttime = ''
				this.Search()
			}
		},

		getThisMonth() {
			const nowDate = new Date()
			const nowTimeStamp = nowDate.getTime()
			const nowYear = nowDate.getFullYear()
			const nowMonth = nowDate.getMonth() + 1
			const nowDay = nowDate.getDate()

			const startTimeStamp = nowTimeStamp - (3600 * 1000 * 24 * 180)
			const startDate = new Date(startTimeStamp)
			const startYear = startDate.getFullYear()
			const startMonth = startDate.getMonth() + 1
			const startDay = startDate.getDate()
			this.ruleForm.starttime = `${startYear}-${startMonth}-${startDay} 00:00:00`
			this.ruleForm.endtime = `${nowYear}-${nowMonth}-${nowDay} 23:59:59`
		},
	},
}
</script>
<style lang="scss" scoped>
.RRR {
	color: red;
}

.FBMOrder {
	width: 98%;
	position: relative;

	.el-divider--horizontal.orderDivider {
		margin: 10px 0;
	}

	.custom-formScreen {
		::v-deep {
			.el-form-item__content {
				width: calc(100% - 120px);
			}
		}
	}

	.el-table {
		font-size: 12px;
	}

	.FBMOrder_top {
		overflow: hidden;
		border-bottom: 1px #eee solid;

		h3 {
			float: left;
			margin-bottom: 20px;
		}

		div {
			float: right;
		}
	}

	.el-tag--dark {
		border: 0;
	}

	::v-deep {
		.el-form-item__label {
			width: 120px;
			// text-align: center;
		}
	}

	.order_list {
		position: relative;

		// overflow: hidden;
		.search-result {
			overflow: hidden;
			background: #f9f3f3;
			padding: 0 12px 10px;
			// .right {
			// 	float: right;
			// }
		}

		.search-result-text {
			font-size: 14px;
			color: #606266;
			width: 230px;
			line-height: 40px;

			// float: left;
			span {
				color: #f56c6c;
				font-size: 16px;
			}
		}

		.cell {
			.scope_img {
				display: initial;
			}
		}
	}

	.el-table {
		overflow: initial;
	}

	.el-table__body-wrapper {
		overflow: initial;
	}

	a {
		color: #409eff;
	}

	.details {
		display: flex;
		justify-content: space-between;
		align-items: center;
	}

	.details_left {
		width: 30%;
		text-align: center;
	}

	.details_right {
		width: 70%;
		display: flex;
		align-items: center;
		flex-wrap: wrap;
	}

	.page {
		position: fixed;
		width: 100%;
		bottom: 0;
		background-color: white;
		display: flex;
		justify-content: center;
		align-items: center;
		height: 50px;
		z-index: 99;
	}

	.scope_img img {
		width: 55px;
		height: 55px;
	}

	.Memo {
		width: 25px;
		height: 25px;
	}

	.Memo1 {
		width: 17px;
		height: 19px;
	}

	.search-result.oh /deep/ .el-button+.el-button {
		margin-right: 0.48828vw;
	}
}
.icon-button{
	font-size: 22px;
}
.header-group{
	display: flex;
	width: 100%;
	flex-wrap: wrap;
	.el-checkbox{
		width: 40%;
	}
}
.popover-title{
	font-size: 16px;
	font-weight: bold;
	margin-bottom: 10px;
}
</style>
